/* MV Sortiment assets/mv-sortiment.standort.js · Agent W-S · 2026-10-07 */
/*
  Standort-Check mit Sofortergebnis (Paket W-S; Inhaber 06.10.2026 zu pulse-vending.de/standortanalyse: "geil" -
  wir wollen es deutlich besser: Ergebnis sofort im Browser, offengelegte Faktoren, Geraetebezug).
  Vertrag, Faktoren, Annahmen mit Quelle, URL-Kodierung: _docs/w-standort.md.

  Teil 1 - reine Logik ohne DOM (unter Node auf module.exports, _tests/w-standort.test.mjs):
    - Zustand der zehn Schritte pruefen und kompakt kodieren (Hash #sc=1:...), Annahmen je Standorttyp.
    - Punktzahl 0-100 = Summe aus fuenf gewichteten Faktoren (GEWICHTE, WERTE), K.-o.-Faelle (kein Strom, kein Geraet
      passt durch die gemessene engste Stelle) und Nachfrage-Deckel, Ampel gruen/gelb/rot.
    - Verkaufsprognose als Spanne: Personen (Klasse) x Kaufquote x Sichtbarkeit x Zugang x Versorgung.
    - Geraete aus dem JSON-Datenblock der Sektion: Masse-Parser, Passform gegen Einbringweg und Stellflaeche,
      Variante je Geraet, Rangfolge, Empfehlung, Strom und Stromkosten, Rate in Verkaeufen.
    - Texte fuer Ergebnis, Kurzfassung (data-konfiguration), Nachricht (data-nachricht) und WhatsApp.
    Geld (Umsatz, Ueberschuss, Monate), Zahlformat, Kalkulator-Link und Kurzfassung kommen aus dem Modul "rechner"
    (assets/mv-sortiment.rechner.js, Paket D5, Version 2026-10-07.1): gleiche Rechnung, gleiche Standardannahmen,
    keine Kopie. Im Browser liegt es auf window.__mvSortiment.rechner, unter Node verbindet es verbindeRechner().
    Ohne Modul liefern die Geldfunktionen null (Anzeige "-"), alles andere rechnet weiter.
  Teil 2 - Browser: Waechter window.__mvSortiment.standort, Delegation auf document (auch shopify:section:load),
    Druck ueber beforeprint/afterprint auf window. Schritte mit Fortschritt, Zeiger-Klick springt weiter, Tastatur
    nicht; Zustand per history.replaceState im Hash; Ergebnis nur per textContent; Lightbox-Oeffner mit
    data-konfiguration und data-nachricht (snippets/mv-anfrage-modal.liquid); Analytics standort_check_schritt,
    standort_check_ergebnis, standort_check_cta und das Ereignis mv:standort:ergebnis.
  Sichtbare Texte stehen in TEXTE und LABELS, Umlaute als \u-Escapes (Datei bleibt ASCII).
  Nachtrag K-2 (07.10.2026, _docs/k2-werkzeuge.md): Hinweis Alterswaren nach JuSchG - Alkohol am frei zugaenglichen
  Automaten nicht zulaessig, auch nicht mit Alterspruefung (Paragraf 9 Abs. 3), Tabak und E-Zigaretten nur mit
  Alterspruefung am Geraet, Energy-Drinks freiwillig; Link auf den Beitrag wissen-jugendschutz-gesetz-und-praxis;
  Kartengebuehren im Annahmen-Text als Beispielwerte gekennzeichnet (Inhaberfrage 35). Nachtrag aus I-1 (i1-inhalte.md
  Abschnitt 12): Tipp zum Zugang verlinkt den R-W-Beitrag aufstellungsvertrag-in-der-praxis statt der Stellplatzvereinbarung.
  Nachtrag A-2b (10.10.2026, _docs/a2b-konto-werkzeuge.md): Die Antworten speichern ueber das Kundenkonto
  (assets/mv-sortiment.konto.js, MVKonto) unter dem Werkzeug-Schluessel "standort-check": Stand { v: 1, zustand,
  annahmen, titel } (normalisiert wie im Hash, titel = Standorttyp und Sortiment fuer "Meine Werkzeuge"). Bisher stand
  der Zustand nur im Hash; neu kommt er beim naechsten Besuch wieder (ohne Login aus dem Browser-Spiegel
  mv-konto:standort-check, mit Login aus dem Konto). Hash und Vorbelegung aus der Adresse (?typ=, ?sortiment=, ?bon=,
  ?tage=) gehen vor. Gespeichert wird jede Aenderung (urlSchreiben), nie der Start; "Neu starten" loescht den Stand.
  Mit Login zeigt die Seite einen abweichenden Konto-Stand (anderes Geraet, im Konto geloescht), solange sie nicht aus
  einem Link kam und noch nichts beantwortet wurde; sonst gilt die Seite und geht ins Konto. Statuszeile
  [data-mv-konto-hinweis] im Kopf der Sektion. Ohne MVKonto bleibt alles wie bisher.
*/
(function () {
  'use strict';

  var VERSION = '2026-10-07.2';

  // ===========================================================================================
  // Teil 1: Logik
  // ===========================================================================================

  var FELDER = ['typ', 'publikum', 'groesse', 'zugang', 'sicht', 'versorgung', 'sortiment', 'aufstellort', 'strom', 'tuer', 'treppe', 'breite', 'tiefe', 'masse'];
  var SCHRITTE = [['typ'], ['publikum'], ['groesse'], ['zugang'], ['sicht'], ['versorgung'], ['sortiment'], ['aufstellort'], ['strom'], ['tuer', 'treppe', 'breite', 'tiefe', 'masse']];
  var ZAHL_FELDER = ['tuer', 'breite', 'tiefe'];
  var ERLAUBT = {
    typ: ['buero', 'produktion', 'fitness', 'schule', 'klinik', 'hotel', 'handel', 'wohnen', 'aussen'],
    publikum: ['gebunden', 'fluechtig'],
    groesse: ['s', 'm', 'l', 'xl'],
    zugang: ['rund', 'zeiten', 'zeitweise'],
    sicht: ['eingang', 'pause', 'neben'],
    versorgung: ['keine', 'kiosk', 'kantine'],
    sortiment: ['snack', 'getraenke', 'kombi', 'kaffee', 'tiefkuehl'],
    aufstellort: ['innen', 'ueberdacht', 'frei'],
    strom: ['platz', 'naehe', 'unklar', 'keiner'],
    treppe: ['nein', 'aufzug', 'ja'],
    masse: ['geschaetzt', 'gemessen']
  };
  // Ein Zeichen je Antwort fuer den Hash (Vertrag _docs/w-standort.md Abschnitt 7)
  var CODES = {
    typ: { buero: 'b', produktion: 'p', fitness: 'f', schule: 's', klinik: 'k', hotel: 'h', handel: 'l', wohnen: 'w', aussen: 'a' },
    publikum: { gebunden: 'g', fluechtig: 'f' },
    groesse: { s: '1', m: '2', l: '3', xl: '4' },
    zugang: { rund: 'r', zeiten: 'z', zeitweise: 'w' },
    sicht: { eingang: 'e', pause: 'p', neben: 'n' },
    versorgung: { keine: 'k', kiosk: 'i', kantine: 'a' },
    sortiment: { snack: 's', getraenke: 'g', kombi: 'k', kaffee: 'c', tiefkuehl: 't' },
    aufstellort: { innen: 'i', ueberdacht: 'u', frei: 'f' },
    strom: { platz: 'p', naehe: 'n', unklar: 'u', keiner: 'k' },
    treppe: { nein: 'n', aufzug: 'a', ja: 'j' },
    masse: { geschaetzt: 's', gemessen: 'm' }
  };
  var ZAHL_GRENZEN = { tuer: [40, 400], breite: [40, 400], tiefe: [40, 400] };
  // Standardwerte von Schritt 10 (Zentimeter): 90 = lichte Mindestbreite barrierefreier Tueren; Flaeche fuer ein
  // Standgeraet mit Abstaenden; "geschaetzt", bis die Kundin oder der Kunde gemessen hat
  var STANDARD_WEG = { tuer: 90, treppe: 'nein', breite: 130, tiefe: 120, masse: 'geschaetzt' };

  // Punktzahl: Gewichte (Summe 100) und Werte 0..1 je Antwort (Herleitung _docs/w-standort.md Abschnitt 3)
  var GEWICHTE = { nachfrage: 35, zugang: 15, sicht: 15, versorgung: 10, machbarkeit: 25 };
  var MACHBARKEIT = { strom: 10, weg: 8, platz: 7 };
  var WERTE = {
    zugang: { rund: 1, zeiten: 0.8, zeitweise: 0.45 },
    sicht: { eingang: { gebunden: 1, fluechtig: 1 }, pause: { gebunden: 1, fluechtig: 0.75 }, neben: { gebunden: 0.6, fluechtig: 0.35 } },
    versorgung: { keine: { sonst: 1, rund: 1 }, kiosk: { sonst: 0.8, rund: 0.85 }, kantine: { sonst: 0.6, rund: 0.7 } },
    strom: { platz: 1, naehe: 0.7, unklar: 0.4, keiner: 0 },
    passform: { passt: 1, knapp: 0.6, unbekannt: 0.5, nicht: 0, nichtGeschaetzt: 0.3, ohneGeraet: 0.5 },
    treppe: { nein: 1, aufzug: 0.85, ja: 0.6 }
  };
  // Nachfrage = erwartete Kaeufe am Tag vor Abzuegen (Personen der Klassenmitte x Kaufquote) / NACHFRAGE_ZIEL, hoechstens 1.
  // 15 Verkaeufe am Tag liegen in der Mitte der BDV-abgeleiteten Durchschnitte je Automat (Recherche 2.2: Snack 11-12,
  // Kaltgetraenke 17, alle 19). Ohne ausreichende Nachfrage macht kein anderer Faktor den Standort gruen (Deckel).
  var NACHFRAGE_ZIEL = 15;
  var NACHFRAGE_DECKEL = [[0.2, 44], [0.5, 69]];
  var AMPEL = { gruen: 70, gelb: 45 };
  var KO_DECKEL = 30;
  // Personen am Tag je Klasse: [konservativ (untere Grenze), erwartet (Klassenmitte; offene Klasse x 4/3)]
  var PERSONEN = { s: [10, 20], m: [30, 65], l: [100, 200], xl: [300, 400] };
  // Passform in Millimetern: Spielraum am Einbringweg, je Seite 25 mm, Wandabstand fuer die Lueftung
  var SPIEL = { tuer: 20, seite: 50, wand: 100 };
  var HOCH_MM = 2000;
  var STARK_W = 2000;
  // Groesse der Variante wie im Automaten-Finder (Auswahlen): unter 40 kompakt, bis 60 mittel, darueber gross
  var SCHWELLEN = { s: 40, l: 60 };
  var GROESSE_ZIEL = { s: 's', m: 'm', l: 'l', xl: 'l' };
  var GROESSEN_RANG = { s: 0, m: 1, l: 2 };
  var MAX_GERAETE = 4;
  var SORTIMENT_TYPEN = { snack: ['snack', 'tisch'], getraenke: ['getraenke'], kombi: ['kombi'], kaffee: ['kaffee'], tiefkuehl: ['tiefkuehl'] };
  var NIE_TYPEN = ['erweiterung', 'zahlungssystem', 'zubehoer', 'service', 'micro-market'];

  // Standardannahmen: Geld wie das Rechenbeispiel D5 (Schema-Standards von sections/mv-rechner-teaser.liquid, der Test
  // vergleicht), dazu die Annahmen des Checks (Kaufquoten, Strompreis, Zeitraum der Rate)
  var STANDARD_ANNAHMEN = {
    quoteGebunden: 20, quoteFluechtig: 3,
    wareneinsatz: 50, grundkosten: 65, karteFix: 14, karteProzent: 2.5, kartenanteil: 55,
    miete: 'prozent', mieteProzent: 10, mieteFix: 100, ustAbziehen: true, mwst: 13,
    strompreis: 0.27, rateMonate: 60
  };
  // Je Standorttyp: \u00d8-Bon brutto und Verkaufstage im Monat (die sechs Branchen wie die D5-Reiter)
  var JE_TYP = {
    buero: { bon: 2.2, tage: 21 }, produktion: { bon: 2.2, tage: 26 }, fitness: { bon: 2.8, tage: 30 },
    schule: { bon: 1.8, tage: 19 }, klinik: { bon: 2.4, tage: 30 }, hotel: { bon: 3, tage: 30 },
    handel: { bon: 2.5, tage: 26 }, wohnen: { bon: 2.5, tage: 30 }, aussen: { bon: 2.5, tage: 30 }
  };
  // [Kurzname im Hash, Schluessel, min, max]
  var ANNAHMEN = [
    ['qg', 'quoteGebunden', 0, 100], ['qf', 'quoteFluechtig', 0, 100], ['bon', 'bon', 0.1, 50], ['tg', 'tage', 1, 31],
    ['we', 'wareneinsatz', 0, 100], ['sp', 'strompreis', 0, 5], ['rm', 'rateMonate', 1, 120], ['gk', 'grundkosten', 0, 10000],
    ['kf', 'karteFix', 0, 1000], ['kp', 'karteProzent', 0, 100], ['ka', 'kartenanteil', 0, 100], ['mi', 'mieteProzent', 0, 100],
    ['mw', 'mwst', 0, 100], ['ua', 'ustAbziehen', 0, 1]
  ];
  // Werte von contact[Standorttyp] der Lightbox (snippets/mv-anfrage-felder.liquid)
  var STANDORTTYP_ANFRAGE = {
    buero: 'B\u00fcro / Unternehmen', produktion: 'Lager / Produktion', fitness: 'Fitnessstudio', schule: 'Schule / Hochschule',
    klinik: 'Krankenhaus / Pflegeeinrichtung', hotel: 'Hotel', handel: 'Sonstiger Standort', wohnen: 'Bahnhof / \u00f6ffentlicher Bereich',
    aussen: 'Sonstiger Standort'
  };
  var WISSEN = {
    standort: '/pages/wissen-standort-waehlen',
    lohnt: '/pages/wissen-lohnt-sich-ein-automat',
    indoor: '/pages/wissen-indoor-oder-outdoor',
    outdoor: '/pages/wissen-outdoor-standort-vorbereiten',
    strom: '/pages/wissen-stromanschluss-und-absicherung',
    transport: '/pages/wissen-transport-und-aufstellort',
    standgeld: '/pages/wissen-standgeld-und-provision',
    aufstellungsvertrag: '/pages/wissen-aufstellungsvertrag-in-der-praxis',
    sortiment: '/pages/wissen-sortiment-nach-standort-und-saison',
    kaffee: '/pages/wissen-kaffeeautomat-grundlagen',
    jugendschutz: '/pages/wissen-jugendschutz-gesetz-und-praxis'
  };
  // Query-Vorbelegung (Uebergabe aus Rechner-Teaser oder Finder): Aliasse auf die eigenen Werte
  var ALIAS = {
    typ: { 'produktion-werkstatt': 'produktion', werkstatt: 'produktion', lager: 'produktion', bueros: 'buero', fitnessstudio: 'fitness', hochschule: 'schule', pflege: 'klinik', gastgewerbe: 'hotel', laden: 'handel', oeffentlich: 'wohnen', outdoor: 'aussen', draussen: 'aussen' },
    sortiment: { snacks: 'snack', getraenk: 'getraenke', drinks: 'getraenke', frozen: 'tiefkuehl', eis: 'tiefkuehl', beides: 'kombi' }
  };

  var LABELS = {
    typ: { buero: 'B\u00fcro & Verwaltung', produktion: 'Produktion & Logistik', fitness: 'Fitnessstudio', schule: 'Schule & Hochschule', klinik: 'Klinik & Pflege', hotel: 'Hotel & Gastgewerbe', handel: 'Handel & Ladenlokal', wohnen: 'Wohnanlage & \u00f6ffentlicher Raum', aussen: 'Au\u00dfenstandort' },
    publikum: { gebunden: 'Gebundenes Publikum', fluechtig: 'Fl\u00fcchtiges Publikum' },
    groesse: { s: 'bis 30 Personen', m: '30 bis 100 Personen', l: '100 bis 300 Personen', xl: '\u00fcber 300 Personen' },
    zugang: { rund: 'Rund um die Uhr', zeiten: 'Zu Arbeits- oder \u00d6ffnungszeiten', zeitweise: 'Nur zeitweise' },
    sicht: { eingang: 'Am Eingang oder Hauptweg', pause: 'Im Pausenraum oder Aufenthaltsbereich', neben: 'Im Nebenraum' },
    versorgung: { keine: 'Nichts in der N\u00e4he', kiosk: 'Kiosk oder B\u00e4cker', kantine: 'Kantine oder Supermarkt' },
    sortiment: { snack: 'Snacks', getraenke: 'Getr\u00e4nke', kombi: 'Snacks und Getr\u00e4nke', kaffee: 'Kaffee', tiefkuehl: 'Tiefk\u00fchl oder Eis' },
    aufstellort: { innen: 'Innen', ueberdacht: 'Au\u00dfen, \u00fcberdacht', frei: 'Au\u00dfen, frei' },
    strom: { platz: 'Steckdose 230 V am Platz', naehe: 'Steckdose in der N\u00e4he', unklar: 'Noch unklar', keiner: 'Kein Anschluss m\u00f6glich' },
    treppe: { nein: 'Keine Treppen', aufzug: 'Aufzug', ja: 'Treppen' },
    masse: { geschaetzt: 'gesch\u00e4tzt', gemessen: 'gemessen' }
  };
  var KURZ = {
    typ: 'Standort', publikum: 'Publikum', groesse: 'Personen am Tag', zugang: 'Zugang', sicht: 'Sichtbarkeit', versorgung: 'Versorgung',
    sortiment: 'Sortiment', aufstellort: 'Aufstellort', strom: 'Strom', tuer: 'Engste Stelle', treppe: 'Treppen', breite: 'Stellfl\u00e4che',
    masse: 'Ma\u00dfe'
  };
  var FAKTOR_NAMEN = { nachfrage: 'Nachfrage', zugang: 'Zugangszeiten', sicht: 'Sichtbarkeit', versorgung: 'Versorgungsl\u00fccke', machbarkeit: 'Machbarkeit' };

  var TEXTE = {
    nbsp: '\u00a0',
    trenner: ' \u00b7 ',
    mal: ' \u00d7 ',
    strich: '\u2013',
    ca: '\u2248',
    fortschritt: 'Schritt {n} von {gesamt}: {name}',
    ergebnis: 'Ergebnis',
    ampel: { gruen: 'Guter Standort', gelb: 'Standort mit Potenzial', rot: 'Standort kritisch' },
    punkte: '{p} von 100 Punkten',
    faktorPunkte: '{p} von {max} Punkten',
    satz: {
      gruen: 'Ihr Standort bringt gute Voraussetzungen f\u00fcr einen Automaten mit.',
      gelb: 'Ihr Standort kann funktionieren \u2013 die Faktoren unten zeigen, wo Sie nachbessern k\u00f6nnen.',
      rot: 'An diesem Standort sprechen wichtige Punkte gegen einen Automaten.',
      ko: 'Ein Punkt verhindert den Betrieb \u2013 erst wenn er gel\u00f6st ist, lohnt der Blick auf die \u00fcbrigen Faktoren.',
      deckel: ' Die Nachfrage begrenzt die Punktzahl: Ohne genug K\u00e4ufer macht kein anderer Faktor den Standort gr\u00fcn.'
    },
    ko: {
      strom: 'Kein Stromanschluss m\u00f6glich: Ohne Steckdose am Stellplatz l\u00e4uft kein Automat.',
      tuer: 'Kein passendes Ger\u00e4t kommt durch die engste Stelle auf dem Weg ({cm} cm, gemessen).'
    },
    grund: {
      nachfrage: '{klasse} am Tag, {publikum}: rund {kaeufe} K\u00e4ufe am Tag vor Abz\u00fcgen.',
      publikum: { gebunden: 'die t\u00e4glich wiederkommen', fluechtig: 'meist Laufkundschaft' },
      zugang: {
        rund: 'Rund um die Uhr erreichbar \u2013 der Automat verkauft auch abends und am Wochenende.',
        zeiten: 'Erreichbar zu Arbeits- oder \u00d6ffnungszeiten \u2013 au\u00dferhalb davon ruht der Verkauf.',
        zeitweise: 'Nur zeitweise erreichbar \u2013 an den \u00fcbrigen Tagen verkauft der Automat nichts.'
      },
      sicht: {
        eingang: 'Am Eingang oder Hauptweg kommt jeder am Automaten vorbei.',
        pauseGebunden: 'Im Pausenraum kaufen Stammkunden dort, wo sie Pause machen.',
        pauseFluechtig: 'Im Aufenthaltsbereich sehen nicht alle G\u00e4ste den Automaten.',
        neben: 'Im Nebenraum wird ein Automat leicht \u00fcbersehen.'
      },
      versorgung: {
        keine: 'In der N\u00e4he gibt es nichts zu kaufen \u2013 der Automat schlie\u00dft eine L\u00fccke.',
        kiosk: 'Kiosk oder B\u00e4cker in der N\u00e4he decken einen Teil des Bedarfs.',
        kantine: 'Kantine oder Supermarkt sind zu ihren \u00d6ffnungszeiten starke Konkurrenz.',
        rund: ' Rund um die Uhr verkauft der Automat auch dann, wenn dort geschlossen ist.'
      },
      strom: { platz: 'Steckdose am Platz', naehe: 'Steckdose in der N\u00e4he', unklar: 'Strom noch unklar', keiner: 'kein Stromanschluss' },
      passform: { passt: 'passt', knapp: 'knapp', nicht: 'passt nicht', unbekannt: 'nicht pr\u00fcfbar' },
      machbarkeit: '{strom}. Beste Passform: {geraet} \u2013 Einbringweg {weg}, Stellfl\u00e4che {platz}.',
      ohneMasse: '{strom}. Die Ma\u00dfe der Ger\u00e4te pr\u00fcfen wir mit Ihnen.',
      ohneGeraet: '{strom}. F\u00fcr diese Kombination f\u00fchren wir kein Ger\u00e4t.',
      treppe: ' Treppen auf dem Weg erschweren den Transport.',
      aufzug: ' Auf dem Weg liegt ein Aufzug.'
    },
    tipp: {
      nachfrage: { gebunden: 'Stimmen Sie das Sortiment auf Pausen und Schichten ab \u2013 wer l\u00e4nger bleibt, kauft \u00f6fter.', fluechtig: 'Laufkundschaft kauft spontan: ein Platz am Hauptweg und bekannte Marken helfen.' },
      zugang: { rund: 'Halten Sie Zugang und Strom im Aufstellungsvertrag fest.', sonst: 'W\u00e4hlen Sie, wenn m\u00f6glich, einen Platz, der auch vor und nach den Kernzeiten zug\u00e4nglich ist.' },
      sicht: { eingang: 'Eine gut beleuchtete Front zeigt das Sortiment schon von Weitem.', sonst: 'Stellen Sie den Automaten an einen Weg, den Ihre Kunden ohnehin gehen.' },
      versorgung: { keine: 'Ein Sortiment f\u00fcr den ganzen Tag nutzt die L\u00fccke: Snacks, Getr\u00e4nke, etwas Herzhaftes.', sonst: 'Planen Sie den Automaten f\u00fcr die Zeiten, in denen sonst nichts ge\u00f6ffnet hat.' },
      machbarkeit: {
        strom: 'Lassen Sie eine Schutzkontaktsteckdose mit 230 V am Stellplatz setzen; eine Elektrofachkraft pr\u00fcft den Stromkreis.',
        weg: 'Messen Sie T\u00fcren, Flure, Treppen und Aufzug \u2013 neben der Breite z\u00e4hlt die Tiefe des Ger\u00e4ts.',
        platz: 'Planen Sie Abstand zur Wand f\u00fcr die L\u00fcftung und Platz zum \u00d6ffnen der T\u00fcr beim Bef\u00fcllen.',
        outdoor: 'Drau\u00dfen braucht der Automat einen befestigten Stellplatz, eine frostsichere Zuleitung und eine Befestigung.',
        gut: 'Pr\u00fcfen Sie vor dem Liefertag Boden, Zufahrt und einen Ansprechpartner vor Ort.'
      }
    },
    tippLink: {
      standort: 'Den Standort w\u00e4hlen', lohnt: 'Lohnt sich ein Automat?', outdoor: 'Outdoor-Standort vorbereiten', strom: 'Stromanschluss und Leistungsaufnahme',
      transport: 'Transportweg und Aufstellort', aufstellungsvertrag: 'Der Aufstellungsvertrag in der Praxis', sortiment: 'Sortiment nach Standort', kaffee: 'Kaffeeautomat: Grundlagen',
      jugendschutz: 'Jugendschutz am Automaten: Gesetz und Praxis', standgeld: 'Standgeld und Provision', indoor: 'Indoor oder Outdoor?'
    },
    hinweis: {
      messen: 'Die Ma\u00dfe sind Standardwerte. Messen Sie die engste Stelle auf dem Weg und die freie Stellfl\u00e4che \u2013 dann wird die Passform belastbar.',
      // K-2: Paragraf 9 Abs. 3 JuSchG - Alkohol nur an einem fuer Minderjaehrige unzugaenglichen Ort oder im gewerblich
      // genutzten Raum mit Technik oder Aufsicht; Paragraf 10 Abs. 2 und 4 - Tabak und E-Zigaretten mit Technik genuegt
      alterswaren: 'Alkohol ist an einem frei zug\u00e4nglichen Automaten nicht zul\u00e4ssig \u2013 auch nicht mit Alterspr\u00fcfung (\u00a7\u00a09 Abs.\u00a03 JuSchG): Erlaubt ist er nur an einem f\u00fcr Kinder und Jugendliche unzug\u00e4nglichen Ort oder in einem gewerblich genutzten Raum mit technischer Sicherung oder st\u00e4ndiger Aufsicht. Tabak und E-Zigaretten verkaufen Sie nur mit Alterspr\u00fcfung am Ger\u00e4t; f\u00fcr Energy-Drinks gibt es keine gesetzliche Altersgrenze, eine Pr\u00fcfung ist freiwillig. Dieser Check bewertet solche Artikel nicht.',
      zuleitung: 'Au\u00dfen braucht der Automat eine frostsicher verlegte Zuleitung mit 230 V und eine Boden- oder Wandbefestigung.',
      dach: 'Auch f\u00fcr Outdoor-Ger\u00e4te empfehlen wir einen \u00fcberdachten Platz, damit Ihre Kunden bei Regen bequem einkaufen.',
      treppe: 'Treppen auf dem Weg: Das empfohlene Ger\u00e4t wiegt {kg} kg. Planen Sie Helfer und Transporthilfen ein oder fragen Sie die Aufstellung am Standort an.',
      treppeOhne: 'Treppen auf dem Weg: Planen Sie Helfer und Transporthilfen ein oder fragen Sie die Aufstellung am Standort an.',
      aufzug: 'Aufzug auf dem Weg: Vergleichen Sie Kabinenma\u00dfe, T\u00fcrbreite und Tragf\u00e4higkeit mit Ma\u00dfen und Gewicht des Ger\u00e4ts.',
      hoch: 'Das empfohlene Ger\u00e4t ist {mm} mm hoch \u2013 pr\u00fcfen Sie auch die Durchgangsh\u00f6he der T\u00fcren.',
      stark: 'Das empfohlene Ger\u00e4t nimmt bis zu {w} W auf: Ob Steckdose und Stromkreis daf\u00fcr reichen, kl\u00e4rt eine Elektrofachkraft.',
      kaffee: 'Kaffeeautomaten brauchen zus\u00e4tzlich Wasser: einen Festwasseranschluss oder einen Tank, je nach Ger\u00e4t.',
      zwei: 'Ein Kombiger\u00e4t f\u00fcr diesen Aufstellort f\u00fchren wir nicht; Snacks und Getr\u00e4nke stellen Sie mit zwei Ger\u00e4ten nebeneinander auf.',
      ohneGeraet: 'F\u00fcr diese Kombination aus Sortiment und Aufstellort f\u00fchren wir kein passendes Ger\u00e4t. Wir beraten Sie gern pers\u00f6nlich.',
      stromNaehe: 'Verl\u00e4ngerungskabel sind keine Dauerl\u00f6sung: Lassen Sie die Steckdose an den Stellplatz legen.',
      stromUnklar: 'Kl\u00e4ren Sie den Stromanschluss vorab mit dem Standortgeber.'
    },
    prognose: {
      verkaeufe: '{k} bis {e} Verk\u00e4ufe am Tag',
      verkaeufeGleich: '{e} Verk\u00e4ufe am Tag',
      verkaeufeEins: '{e} Verkauf am Tag',
      verkaeufeNull: 'unter einem Verkauf am Tag',
      unterEins: 'unter 1',
      spanne: '{k} bis {e}',
      rechenweg: 'Rechnung: {pk} bis {pe} Personen \u00d7 {quote} % Kaufquote \u00d7 Sichtbarkeit {s} \u00d7 Zugang {z} \u00d7 Versorgung {v} = {k} bis {e} Verk\u00e4ufe am Tag. Umsatz = Verk\u00e4ufe \u00d7 {bon} \u20ac \u00d8-Bon \u00d7 {tage} Verkaufstage; \u00dcberschuss nach Wareneinsatz ({we} %), {ust}Kartenzahlung, Standortmiete ({mi} %) und Grundkosten ({gk} \u20ac im Monat).',
      ust: 'Umsatzsteuer ({mw} %), ',
      annahmen: 'Ihre Annahmen: Kaufquote {qg} % (gebunden) bzw. {qf} % (fl\u00fcchtig), \u00d8-Bon {bon} \u20ac brutto, {tage} Verkaufstage im Monat, Wareneinsatz {we} %, Grundkosten {gk} \u20ac im Monat, Kartenzahlung {kf} \u20ac im Monat plus {kp} % bei {ka} % Kartenanteil (Beispielwerte, nicht die Konditionen Ihres Zahlungsanbieters), Standortmiete {mi} %, {ustText}, Strompreis {sp} \u20ac je kWh, Zeitraum der Rate {rm} Monate.',
      ustAn: 'Umsatzsteuer im Mittel {mw} % abgezogen',
      ustAus: 'ohne Abzug der Umsatzsteuer'
    },
    tabelle: {
      merkmal: 'Merkmal',
      geraet: 'Ger\u00e4t',
      preis: 'Preis',
      masse: 'Ma\u00dfe (H \u00d7 B \u00d7 T)',
      weg: 'Einbringweg',
      platz: 'Stellfl\u00e4che',
      gewicht: 'Gewicht',
      strom: 'Strom',
      energie: 'Energie',
      stromkosten: 'Stromkosten im Jahr',
      bezahlt: 'Bezahlt nach',
      rate: 'Rate in Verk\u00e4ufen',
      empfehlung: 'Empfehlung',
      preisWert: 'ab {preis} \u20ac netto',
      masseWert: '{h} \u00d7 {b} \u00d7 {t} mm',
      unbekannt: 'nennen wir im Angebot',
      status: { passt: 'passt', knapp: 'knapp', nicht: 'passt nicht', unbekannt: 'nicht pr\u00fcfbar' },
      braucht: 'braucht {cm} cm',
      brauchtFlaeche: 'braucht {b} \u00d7 {t} cm',
      kg: '{kg} kg',
      watt: '{w} W',
      energieWert: 'Klasse {klasse} \u00b7 {kwh} kWh im Jahr',
      energieOhneKlasse: '{kwh} kWh im Jahr',
      kosten: '\u2248 {betrag} \u20ac im Jahr',
      monate: 'nach \u2248 {n} Monaten',
      monat: 'nach \u2248 {n} Monat',
      lang: 'nach mehr als f\u00fcnf Jahren',
      nie: 'bei diesen Annahmen nicht',
      rateWert: '\u2248 {v} Verk\u00e4ufe am Tag in {m} Monaten',
      rateEins: '\u2248 {v} Verkauf am Tag in {m} Monaten',
      caption: 'Passende Ger\u00e4te f\u00fcr Ihren Standort im Vergleich',
      keine: 'F\u00fcr diese Angaben f\u00fchren wir kein passendes Ger\u00e4t.'
    },
    empfehlung: {
      variante: 'Variante {titel}',
      weg: { passt: 'passt durch die engste Stelle (braucht {cm} cm)', knapp: 'passt knapp durch die engste Stelle (braucht {cm} cm)', nicht: 'braucht mindestens {cm} cm auf dem Weg', unbekannt: 'Einbringweg pr\u00fcfen wir mit Ihnen' },
      platz: { passt: 'passt auf Ihre Stellfl\u00e4che', knapp: 'passt knapp auf Ihre Stellfl\u00e4che', nicht: 'braucht {b} \u00d7 {t} cm Stellfl\u00e4che', unbekannt: 'Stellfl\u00e4che pr\u00fcfen wir mit Ihnen' },
      auswahlen: '{n} Auswahlen f\u00fcr {klasse} am Tag',
      outdoor: 'f\u00fcr den Au\u00dfenbereich gebaut',
      alternative: 'Alternative: ',
      zwei: 'Dazu ein zweites Ger\u00e4t f\u00fcr das andere Sortiment: '
    },
    kurz: {
      kopf: 'Standort-Check: {p} von 100 Punkten ({ampel})',
      verkaeufe: 'Verk\u00e4ufe am Tag: {spanne}',
      empfehlung: 'Empfehlung: {geraet}',
      tuer: '{cm} cm',
      flaeche: '{b} \u00d7 {t} cm',
      nachricht: 'Bitte pr\u00fcfen Sie meinen Standort pers\u00f6nlich. Mein Ergebnis im Standort-Check: {p} von 100 Punkten ({ampel}), erwartet {spanne} Verk\u00e4ufe am Tag{geraet}. Link zum Ergebnis: {link}',
      nachrichtGeraet: ', empfohlen: {geraet}',
      whatsapp: '{text} Mein Ergebnis: {p} von 100 Punkten ({ampel}). {link}'
    },
    status: {
      ergebnis: 'Ergebnis: {p} von 100 Punkten, {ampel}.',
      kopiert: 'Link kopiert.',
      kopierenFehler: 'Kopieren war nicht m\u00f6glich \u2013 bitte den Link aus der Adresszeile kopieren.'
    },
    fehler: 'Bitte w\u00e4hlen Sie eine Antwort.',
    fehlerZahl: 'Bitte geben Sie die Ma\u00dfe in Zentimetern an (40 bis 400).'
  };

  function istObjekt(x) {
    return !!x && typeof x === 'object' && !Array.isArray(x);
  }

  function hat(o, k) {
    return Object.prototype.hasOwnProperty.call(o, k);
  }

  function text(x) {
    return x == null ? '' : String(x);
  }

  function enthaelt(liste, wert) {
    return liste.indexOf(wert) !== -1;
  }

  function ersetze(vorlage, werte) {
    return text(vorlage).replace(/\{(\w+)\}/g, function (ganz, name) {
      return hat(werte, name) ? text(werte[name]) : ganz;
    });
  }

  function slug(wert) {
    var s = text(wert).toLowerCase()
      .replace(/\u00e4/g, 'ae').replace(/\u00f6/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\u00df/g, 'ss');
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function vergleicheListen(a, b) {
    for (var i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return a[i] < b[i] ? -1 : 1;
    }
    return 0;
  }

  // Zahl deutsch oder englisch: "1.290", "2,50", "2.5", " 90 " -> Zahl, sonst NaN
  function zahlDe(wert) {
    if (typeof wert === 'number') return isFinite(wert) ? wert : NaN;
    var s = text(wert).replace(/[\s\u00a0]/g, '');
    if (!s) return NaN;
    if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(s)) s = s.replace(/\./g, '').replace(',', '.');
    else s = s.replace(',', '.');
    return /^-?\d+(\.\d+)?$/.test(s) ? parseFloat(s) : NaN;
  }

  function ganz(n) {
    return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // Dezimalzahl de-DE ohne Endnullen ("0,27", "2,5", "1,0" -> "1")
  function dezimal(n, stellen) {
    if (!isFinite(n)) return TEXTE.strich;
    var f = Math.pow(10, typeof stellen === 'number' ? stellen : 2);
    var r = Math.round(n * f) / f;
    var teile = String(Math.abs(r)).split('.');
    return (r < 0 ? '\u2212' : '') + teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + (teile[1] ? ',' + teile[1] : '');
  }

  // Faktorwert fuer den Rechenweg: immer eine Nachkommastelle mehr als noetig vermeiden ("0,8", "1,0")
  function faktorText(n) {
    var r = Math.round(n * 100) / 100;
    var s = dezimal(r, 2);
    return s.indexOf(',') === -1 ? s + ',0' : s;
  }

  // ---------------------------------------------------------------------------------- Zustand

  function normWert(feld, wert) {
    if (enthaelt(ZAHL_FELDER, feld)) {
      var n = zahlDe(wert);
      if (!isFinite(n)) return undefined;
      n = Math.round(n);
      var g = ZAHL_GRENZEN[feld];
      return n >= g[0] && n <= g[1] ? n : undefined;
    }
    var s = slug(wert);
    if (hat(ALIAS, feld) && hat(ALIAS[feld], s)) s = ALIAS[feld][s];
    return hat(ERLAUBT, feld) && enthaelt(ERLAUBT[feld], s) ? s : undefined;
  }

  function normalisiereZustand(roh) {
    var aus = {};
    if (!istObjekt(roh)) return aus;
    for (var i = 0; i < FELDER.length; i++) {
      var w = normWert(FELDER[i], roh[FELDER[i]]);
      if (w !== undefined) aus[FELDER[i]] = w;
    }
    return aus;
  }

  function normalisiereAnnahmen(roh) {
    var aus = {};
    if (!istObjekt(roh)) return aus;
    for (var i = 0; i < ANNAHMEN.length; i++) {
      var d = ANNAHMEN[i];
      if (!hat(roh, d[1])) continue;
      var w = roh[d[1]];
      if (d[1] === 'ustAbziehen') {
        if (w === true || w === 1 || w === '1' || w === 'true') aus.ustAbziehen = true;
        else if (w === false || w === 0 || w === '0' || w === 'false') aus.ustAbziehen = false;
        continue;
      }
      var n = zahlDe(w);
      if (isFinite(n) && n >= d[2] && n <= d[3]) aus[d[1]] = Math.round(n * 100) / 100;
    }
    return aus;
  }

  // Wirksame Annahmen: Standard, \u00d8-Bon und Verkaufstage des Standorttyps, eigene Werte zuletzt
  function annahmenFuer(zustand, eigene) {
    var z = normalisiereZustand(zustand);
    var typ = hat(JE_TYP, z.typ) ? z.typ : 'buero';
    var a = {};
    for (var k in STANDARD_ANNAHMEN) if (hat(STANDARD_ANNAHMEN, k)) a[k] = STANDARD_ANNAHMEN[k];
    a.bon = JE_TYP[typ].bon;
    a.tage = JE_TYP[typ].tage;
    var e = normalisiereAnnahmen(eigene);
    for (var j in e) if (hat(e, j)) a[j] = e[j];
    return a;
  }

  // Standardwert einer Annahme (fuer "nur Abweichungen speichern")
  function standardAnnahme(schluessel, zustand) {
    var z = normalisiereZustand(zustand);
    var typ = hat(JE_TYP, z.typ) ? z.typ : 'buero';
    if (schluessel === 'bon' || schluessel === 'tage') return JE_TYP[typ][schluessel];
    return STANDARD_ANNAHMEN[schluessel];
  }

  function ersterOffenerSchritt(zustand, ab) {
    var z = normalisiereZustand(zustand);
    for (var i = Math.max(1, ab || 1); i <= SCHRITTE.length; i++) {
      var felder = SCHRITTE[i - 1];
      for (var j = 0; j < felder.length; j++) {
        if (z[felder[j]] === undefined) return i;
      }
    }
    return 0;
  }

  function vollstaendig(zustand) {
    return ersterOffenerSchritt(zustand, 1) === 0;
  }

  function urlZahl(n) {
    return String(Math.round(n * 100) / 100);
  }

  // "1:b,g,2,z,p,k,s,i,p,90,n,130,120,s;bon=2.4,tg=22"
  function kodiere(zustand, eigene) {
    var z = normalisiereZustand(zustand);
    var teile = [];
    for (var i = 0; i < FELDER.length; i++) {
      var f = FELDER[i];
      if (z[f] === undefined) teile.push('');
      else teile.push(enthaelt(ZAHL_FELDER, f) ? String(z[f]) : CODES[f][z[f]]);
    }
    var s = '1:' + teile.join(',');
    var e = normalisiereAnnahmen(eigene);
    var paare = [];
    for (var j = 0; j < ANNAHMEN.length; j++) {
      var d = ANNAHMEN[j];
      if (!hat(e, d[1])) continue;
      paare.push(d[0] + '=' + (d[1] === 'ustAbziehen' ? (e.ustAbziehen ? '1' : '0') : urlZahl(e[d[1]])));
    }
    if (paare.length) s += ';' + paare.join(',');
    return s;
  }

  function dekodiere(eingabe) {
    var aus = { zustand: {}, annahmen: {} };
    var s = text(eingabe).trim();
    try { s = decodeURIComponent(s); } catch (e) { /* Rohtext lesen */ }
    var m = /^1:([^;]*)(?:;(.*))?$/.exec(s);
    if (!m) return aus;
    var teile = m[1].split(',');
    var roh = {};
    for (var i = 0; i < FELDER.length && i < teile.length; i++) {
      var f = FELDER[i];
      var t = teile[i];
      if (!t) continue;
      if (enthaelt(ZAHL_FELDER, f)) {
        if (/^\d+$/.test(t)) roh[f] = t;
        continue;
      }
      for (var wert in CODES[f]) {
        if (hat(CODES[f], wert) && CODES[f][wert] === t) roh[f] = wert;
      }
    }
    aus.zustand = normalisiereZustand(roh);
    if (m[2]) {
      var a = {};
      var paare = m[2].split(',');
      for (var j = 0; j < paare.length; j++) {
        var p = paare[j].split('=');
        for (var k = 0; k < ANNAHMEN.length; k++) {
          if (ANNAHMEN[k][0] === p[0] && p.length === 2 && /^-?\d+(\.\d+)?$/.test(p[1])) a[ANNAHMEN[k][1]] = ANNAHMEN[k][1] === 'ustAbziehen' ? p[1] : Number(p[1]);
        }
      }
      aus.annahmen = normalisiereAnnahmen(a);
    }
    return aus;
  }

  // Hash "#sc=..." geht vor; ohne Hash Vorbelegung aus der Query (?typ=, ?sortiment=, ?bon=, ?tage=)
  function zustandAusUrl(hash, suche) {
    var h = text(hash).replace(/^#/, '');
    var m = /(?:^|&)sc=([^&]*)/.exec(h);
    if (m) {
      var d = dekodiere(m[1]);
      if (Object.keys(d.zustand).length || Object.keys(d.annahmen).length) return d;
    }
    var aus = { zustand: {}, annahmen: {} };
    var q = text(suche).replace(/^\?/, '');
    if (!q) return aus;
    var roh = {};
    var annahmen = {};
    q.split('&').forEach(function (paar) {
      var i = paar.indexOf('=');
      if (i < 1) return;
      var name = paar.slice(0, i);
      var wert;
      try { wert = decodeURIComponent(paar.slice(i + 1).replace(/\+/g, ' ')); } catch (e) { return; }
      if ((name === 'typ' || name === 'sortiment') && !hat(roh, name)) roh[name] = wert;
      if (name === 'bon' && !hat(annahmen, 'bon')) annahmen.bon = wert;
      if (name === 'tage' && !hat(annahmen, 'tage')) annahmen.tage = wert;
    });
    aus.zustand = normalisiereZustand(roh);
    aus.annahmen = normalisiereAnnahmen(annahmen);
    return aus;
  }

  function wegVon(zustand) {
    var z = normalisiereZustand(zustand);
    var w = {};
    for (var k in STANDARD_WEG) if (hat(STANDARD_WEG, k)) w[k] = z[k] !== undefined ? z[k] : STANDARD_WEG[k];
    return w;
  }

  // ---------------------------------------------------------------------------------- Geraetedaten

  // "2030 \u00d7 1150 \u00d7 1000 mm (H \u00d7 B \u00d7 T)" -> { h: 2030, b: 1150, t: 1000 } in mm; cm und m werden umgerechnet
  function masseAus(eingabe) {
    var s = text(eingabe);
    if (!s.trim()) return null;
    var faktor = 1;
    if (/mm/i.test(s)) faktor = 1;
    else if (/cm/i.test(s)) faktor = 10;
    else if (/(\d|\s)m(?![a-z])/i.test(s)) faktor = 1000;
    var zahlen = s.match(/\d{1,3}(?:\.\d{3})+(?:,\d+)?|\d+(?:[.,]\d+)?/g) || [];
    if (zahlen.length < 3) return null;
    var w = [];
    for (var i = 0; i < 3; i++) {
      var n = zahlDe(zahlen[i]);
      if (!isFinite(n) || n <= 0) return null;
      w.push(Math.round(n * faktor));
    }
    return { h: w[0], b: w[1], t: w[2] };
  }

  function kwhAus(eingabe) {
    var m = /(\d{1,3}(?:\.\d{3})+|\d+)(?:,(\d+))?\s*kWh/i.exec(text(eingabe));
    return m ? zahlDe(m[1] + (m[2] ? ',' + m[2] : '')) : null;
  }

  function wattAus(eingabe) {
    var m = /(\d{1,3}(?:\.\d{3})+|\d+)\s*W(?![a-z])/.exec(text(eingabe));
    return m ? zahlDe(m[1]) : null;
  }

  function kgAus(eingabe) {
    var m = /(\d{1,3}(?:\.\d{3})+|\d+)(?:[,.](\d+))?\s*kg/i.exec(text(eingabe));
    if (m) return zahlDe(m[1] + (m[2] ? ',' + m[2] : ''));
    var n = zahlDe(eingabe);
    return isFinite(n) && n > 0 ? n : null;
  }

  function energieKlasse(eingabe) {
    var m = /^\s*([A-G])\s*(?:\u00b7|\u00b7|$)/.exec(text(eingabe));
    return m ? m[1] : null;
  }

  function positiv(x) {
    var n = Number(x);
    return isFinite(n) && n > 0 ? n : null;
  }

  function normalisiereVariante(v) {
    if (!istObjekt(v) || v.id == null || v.id === '') return null;
    var preis = Number(v.preis);
    var titel = text(v.titel).trim();
    if (titel === 'Default Title') titel = '';
    return {
      id: v.id,
      titel: titel,
      preis: isFinite(preis) && preis > 0 ? Math.round(preis) : null,
      masse: masseAus(v.masse),
      auswahlen: positiv(v.auswahlen),
      watt: wattAus(v.leistung),
      kwh: kwhAus(v.energie),
      klasse: energieKlasse(v.energie),
      kg: kgAus(v.gewicht),
      verfuegbar: v.verfuegbar !== false
    };
  }

  function geraeteAus(daten) {
    var roh = Array.isArray(daten) ? daten : (istObjekt(daten) && Array.isArray(daten.geraete) ? daten.geraete : []);
    var aus = [];
    for (var i = 0; i < roh.length; i++) {
      var g = roh[i];
      if (!istObjekt(g) || !text(g.handle)) continue;
      var varianten = [];
      var rv = Array.isArray(g.varianten) ? g.varianten : [];
      for (var j = 0; j < rv.length; j++) {
        var v = normalisiereVariante(rv[j]);
        if (v) varianten.push(v);
      }
      aus.push({
        index: i,
        handle: text(g.handle),
        title: text(g.title) || text(g.handle),
        url: text(g.url) || '/products/' + text(g.handle),
        bild: text(g.bild),
        typ: slug(g.typ),
        standort: slug(g.standort),
        x10: g.x10 === true,
        anschluss: text(g.anschluss).trim(),
        varianten: varianten
      });
    }
    return aus;
  }

  // ---------------------------------------------------------------------------------- Passform

  function cmAuf(mm) {
    return Math.ceil(mm / 10 - 1e-9);
  }

  // Engste Stelle: die schmalere Grundseite muss durch (+ SPIEL.tuer); Stellflaeche: Breite + SPIEL.seite, Tiefe + SPIEL.wand
  function passform(masse, weg) {
    var w = istObjekt(weg) ? weg : {};
    var aus = { tuer: 'unbekannt', platz: 'unbekannt', braucht: null, hoch: false };
    if (!masse) return aus;
    var schmal = Math.min(masse.b, masse.t);
    aus.braucht = { tuer: cmAuf(schmal + SPIEL.tuer), breite: cmAuf(masse.b + SPIEL.seite), tiefe: cmAuf(masse.t + SPIEL.wand) };
    aus.hoch = masse.h > HOCH_MM;
    var tuer = Number(w.tuer) * 10;
    if (isFinite(tuer) && tuer > 0) aus.tuer = tuer >= schmal + SPIEL.tuer ? 'passt' : (tuer >= schmal ? 'knapp' : 'nicht');
    var breite = Number(w.breite) * 10;
    var tiefe = Number(w.tiefe) * 10;
    if (isFinite(breite) && breite > 0 && isFinite(tiefe) && tiefe > 0) {
      if (breite >= masse.b + SPIEL.seite && tiefe >= masse.t + SPIEL.wand) aus.platz = 'passt';
      else if (breite >= masse.b && tiefe >= masse.t) aus.platz = 'knapp';
      else aus.platz = 'nicht';
    }
    return aus;
  }

  var PASSFORM_RANG = { passt: 0, knapp: 1, unbekannt: 1, nicht: 2 };

  function passformRang(pf) {
    return Math.max(PASSFORM_RANG[pf.tuer], PASSFORM_RANG[pf.platz]);
  }

  function groesseVon(auswahlen) {
    var n = Number(auswahlen);
    if (!isFinite(n) || n <= 0) return '';
    if (n < SCHWELLEN.s) return 's';
    if (n > SCHWELLEN.l) return 'l';
    return 'm';
  }

  // Passende Geraete mit der besten Variante je Geraet, sortiert: Passform, Groesse zur Publikumsklasse, Preis, Daten.
  // alle = jede Variante der passenden Geraete (gewaehlte zuerst, in der Rangfolge): Grundlage der Machbarkeit und des
  // K.-o. am Einbringweg - so kann ein breiterer Weg die Punktzahl nie senken (Monotonie).
  function kandidaten(geraete, zustand) {
    var z = normalisiereZustand(zustand);
    var liste = Array.isArray(geraete) ? geraete : geraeteAus(geraete);
    var standort = z.aufstellort ? (z.aufstellort === 'innen' ? 'indoor' : 'outdoor') : '';
    var weg = wegVon(z);
    var ziel = hat(GROESSE_ZIEL, z.groesse) ? GROESSEN_RANG[GROESSE_ZIEL[z.groesse]] : -1;

    function suche(typen) {
      var aus = [];
      var uebrige = [];
      var gesehen = {};
      for (var i = 0; i < liste.length; i++) {
        var g = liste[i];
        if (!g.varianten.length || enthaelt(NIE_TYPEN, g.typ) || !enthaelt(typen, g.typ)) continue;
        if (standort && g.standort !== standort) continue;
        var schluesselGeraet = g.x10 ? 'x10' : g.handle;
        if (hat(gesehen, schluesselGeraet)) continue;
        var beste = null;
        var eintraege = [];
        for (var j = 0; j < g.varianten.length; j++) {
          var v = g.varianten[j];
          var pf = passform(v.masse, weg);
          var gr = groesseVon(v.auswahlen);
          var abstand = ziel === -1 ? 0 : (gr ? Math.abs(GROESSEN_RANG[gr] - ziel) : 3);
          var schluessel = [passformRang(pf), abstand, v.preis == null ? Infinity : v.preis, v.verfuegbar ? 0 : 1, j];
          var eintrag = { geraet: g, variante: v, passform: pf, abstand: abstand, schluessel: schluessel };
          eintraege.push(eintrag);
          if (!beste || vergleicheListen(schluessel, beste.schluessel) < 0) beste = eintrag;
        }
        if (beste) {
          gesehen[schluesselGeraet] = true;
          aus.push(beste);
          for (var e = 0; e < eintraege.length; e++) if (eintraege[e] !== beste) uebrige.push(eintraege[e]);
        }
      }
      aus.sort(function (a, b) {
        return vergleicheListen([a.schluessel[0], a.schluessel[1], a.schluessel[2], a.geraet.index], [b.schluessel[0], b.schluessel[1], b.schluessel[2], b.geraet.index]);
      });
      return { liste: aus, alle: aus.concat(uebrige) };
    }

    var typen = hat(SORTIMENT_TYPEN, z.sortiment) ? SORTIMENT_TYPEN[z.sortiment] : [];
    var gefunden = typen.length ? suche(typen) : { liste: [], alle: [] };
    var zwei = false;
    if (!gefunden.liste.length && z.sortiment === 'kombi') {
      gefunden = suche(['snack', 'getraenke']);
      zwei = gefunden.liste.length > 0;
    }
    return { liste: gefunden.liste, alle: gefunden.alle, zweiGeraete: zwei };
  }

  // ---------------------------------------------------------------------------------- Punktzahl

  function sichtWert(z) {
    var s = WERTE.sicht[z.sicht];
    var p = z.publikum === 'fluechtig' ? 'fluechtig' : 'gebunden';
    return s ? s[p] : null;
  }

  function versorgungWert(z) {
    var v = WERTE.versorgung[z.versorgung];
    return v ? (z.zugang === 'rund' ? v.rund : v.sonst) : null;
  }

  // Kaeufe am Tag vor Abzuegen (Klassenmitte x Kaufquote) - Grundlage von Nachfrage und Prognose
  function kaeufeVorAbzug(z, annahmen) {
    var p = PERSONEN[z.groesse];
    if (!p || !z.publikum) return null;
    var quote = z.publikum === 'fluechtig' ? annahmen.quoteFluechtig : annahmen.quoteGebunden;
    return isFinite(quote) ? p[1] * quote / 100 : null;
  }

  function teil(name, wert) {
    var max = GEWICHTE[name];
    var w = wert == null || !isFinite(wert) ? null : Math.max(0, Math.min(1, wert));
    return { name: name, wert: w, max: max, punkte: w == null ? 0 : Math.round(max * w) };
  }

  function wegWert(pf, z) {
    var w = WERTE.passform[pf.tuer];
    if (pf.tuer === 'nicht') w = z.masse === 'gemessen' ? WERTE.passform.nicht : WERTE.passform.nichtGeschaetzt;
    return w * (hat(WERTE.treppe, z.treppe) ? WERTE.treppe[z.treppe] : 1);
  }

  function platzWert(pf, z) {
    if (pf.platz === 'nicht') return z.masse === 'gemessen' ? WERTE.passform.nicht : WERTE.passform.nichtGeschaetzt;
    return WERTE.passform[pf.platz];
  }

  function faktoren(zustand, annahmen, kand) {
    var z = normalisiereZustand(zustand);
    var a = istObjekt(annahmen) ? annahmen : annahmenFuer(z);
    var k = kand || { liste: [], alle: [], zweiGeraete: false };
    var alle = k.alle || k.liste;
    var kaeufe = kaeufeVorAbzug(z, a);
    var f = {
      nachfrage: teil('nachfrage', kaeufe == null ? null : kaeufe / NACHFRAGE_ZIEL),
      zugang: teil('zugang', hat(WERTE.zugang, z.zugang) ? WERTE.zugang[z.zugang] : null),
      sicht: teil('sicht', sichtWert(z)),
      versorgung: teil('versorgung', versorgungWert(z))
    };
    f.nachfrage.kaeufe = kaeufe;
    var strom = hat(WERTE.strom, z.strom) ? WERTE.strom[z.strom] : null;
    var treppe = hat(WERTE.treppe, z.treppe) ? WERTE.treppe[z.treppe] : 1;
    var bestes = null;
    var weg = WERTE.passform.ohneGeraet * treppe;
    var platz = WERTE.passform.ohneGeraet;
    if (alle.length) {
      var bestWert = -1;
      for (var i = 0; i < alle.length; i++) {
        var c = alle[i];
        var ww = wegWert(c.passform, z);
        var pw = platzWert(c.passform, z);
        var summe = MACHBARKEIT.weg * ww + MACHBARKEIT.platz * pw;
        if (summe > bestWert) {
          bestWert = summe;
          bestes = c;
          weg = ww;
          platz = pw;
        }
      }
    }
    var wert = strom == null ? null : (MACHBARKEIT.strom * strom + MACHBARKEIT.weg * weg + MACHBARKEIT.platz * platz) / GEWICHTE.machbarkeit;
    f.machbarkeit = teil('machbarkeit', wert);
    f.machbarkeit.teile = { strom: strom, weg: weg, platz: platz };
    f.machbarkeit.bestes = bestes;
    return f;
  }

  function bewertung(zustand, geraete, annahmen) {
    var z = normalisiereZustand(zustand);
    var a = istObjekt(annahmen) ? annahmen : annahmenFuer(z);
    var kand = kandidaten(geraete, z);
    var f = faktoren(z, a, kand);
    var summe = 0;
    for (var n in GEWICHTE) if (hat(GEWICHTE, n)) summe += f[n].punkte;
    var ko = [];
    if (z.strom === 'keiner') ko.push('strom');
    if (kand.alle.length && z.masse === 'gemessen') {
      var keins = true;
      for (var i = 0; i < kand.alle.length; i++) if (kand.alle[i].passform.tuer !== 'nicht') keins = false;
      if (keins) ko.push('tuer');
    }
    var punkte = summe;
    var deckel = null;
    for (var d = 0; d < NACHFRAGE_DECKEL.length; d++) {
      if (f.nachfrage.wert != null && f.nachfrage.wert < NACHFRAGE_DECKEL[d][0]) {
        deckel = NACHFRAGE_DECKEL[d][1];
        break;
      }
    }
    if (deckel != null && punkte > deckel) punkte = deckel;
    else deckel = null;
    if (ko.length && punkte > KO_DECKEL) punkte = KO_DECKEL;
    var ampel = ko.length ? 'rot' : (punkte >= AMPEL.gruen ? 'gruen' : (punkte >= AMPEL.gelb ? 'gelb' : 'rot'));
    var empfehlung = kand.liste[0] || null;
    return {
      zustand: z,
      annahmen: a,
      summe: summe,
      punkte: punkte,
      deckel: deckel,
      ampel: ampel,
      ko: ko,
      faktoren: f,
      kandidaten: kand,
      empfehlung: empfehlung,
      alternative: kand.liste[1] || null,
      hinweise: hinweiseVon(z, kand, empfehlung)
    };
  }

  // Hinweise ohne Abzug: [{ code, text, link }]
  function hinweiseVon(z, kand, empfehlung) {
    var aus = [];
    var aussen = z.aufstellort === 'ueberdacht' || z.aufstellort === 'frei';
    var v = empfehlung ? empfehlung.variante : null;
    function neu(code, satz, link) {
      aus.push({ code: code, text: satz, link: link || '', linkText: link ? TEXTE.tippLink[link] : '' });
    }
    if (z.masse !== 'gemessen') neu('messen', TEXTE.hinweis.messen, 'transport');
    if (!kand.liste.length && z.sortiment && z.aufstellort) neu('ohneGeraet', TEXTE.hinweis.ohneGeraet);
    if (kand.zweiGeraete) neu('zwei', TEXTE.hinweis.zwei);
    if (z.strom === 'naehe') neu('stromNaehe', TEXTE.hinweis.stromNaehe, 'strom');
    if (z.strom === 'unklar') neu('stromUnklar', TEXTE.hinweis.stromUnklar, 'strom');
    if (aussen) neu('zuleitung', TEXTE.hinweis.zuleitung, 'outdoor');
    if (z.aufstellort === 'frei') neu('dach', TEXTE.hinweis.dach, 'outdoor');
    if (z.treppe === 'ja') neu('treppe', v && v.kg ? ersetze(TEXTE.hinweis.treppe, { kg: ganz(v.kg) }) : TEXTE.hinweis.treppeOhne, 'transport');
    if (z.treppe === 'aufzug') neu('aufzug', TEXTE.hinweis.aufzug, 'transport');
    if (v && v.masse && v.masse.h > HOCH_MM) neu('hoch', ersetze(TEXTE.hinweis.hoch, { mm: ganz(v.masse.h) }));
    if (v && v.watt && v.watt > STARK_W) neu('stark', ersetze(TEXTE.hinweis.stark, { w: ganz(v.watt) }), 'strom');
    if (z.sortiment === 'kaffee') neu('kaffee', TEXTE.hinweis.kaffee, 'kaffee');
    if (aussen) neu('alterswaren', TEXTE.hinweis.alterswaren, 'jugendschutz');
    return aus;
  }

  // ---------------------------------------------------------------------------------- Prognose und Geld

  function prognose(zustand, annahmen) {
    var z = normalisiereZustand(zustand);
    var a = istObjekt(annahmen) ? annahmen : annahmenFuer(z);
    var p = PERSONEN[z.groesse];
    var quote = z.publikum === 'fluechtig' ? a.quoteFluechtig : (z.publikum === 'gebunden' ? a.quoteGebunden : NaN);
    var fs = { sicht: sichtWert(z), zugang: hat(WERTE.zugang, z.zugang) ? WERTE.zugang[z.zugang] : null, versorgung: versorgungWert(z) };
    if (!p || !isFinite(quote) || fs.sicht == null || fs.zugang == null || fs.versorgung == null) return null;
    var faktor = fs.sicht * fs.zugang * fs.versorgung;
    var roh = [p[0] * quote / 100 * faktor, p[1] * quote / 100 * faktor];
    return { personen: [p[0], p[1]], quote: quote, faktoren: fs, faktor: faktor, roh: roh, verkaeufe: [Math.round(roh[0]), Math.round(roh[1])] };
  }

  var rechnerQuelle = null;

  function verbindeRechner(r) {
    rechnerQuelle = r && typeof r.rechne === 'function' ? r : null;
    return !!rechnerQuelle;
  }

  function rechner() {
    if (rechnerQuelle) return rechnerQuelle;
    if (typeof window !== 'undefined' && window.__mvSortiment && window.__mvSortiment.rechner && typeof window.__mvSortiment.rechner.rechne === 'function') return window.__mvSortiment.rechner;
    return null;
  }

  // Annahmen in der Form von rechne() (Paket D5)
  function rechnerAnnahmen(a) {
    return {
      wareneinsatz: a.wareneinsatz, grundkosten: a.grundkosten, karteFix: a.karteFix, karteProzent: a.karteProzent,
      kartenanteil: a.kartenanteil, miete: 'prozent', mieteProzent: a.mieteProzent, mieteFix: a.mieteFix,
      ustAbziehen: a.ustAbziehen !== false, mwst: a.mwst
    };
  }

  // Umsatz, Ueberschuss und Monate fuer die Spanne; preisCent = Geraetepreis netto in Cent (0 = ohne Geraet)
  function geld(prog, annahmen, preisCent) {
    var R = rechner();
    if (!R || !prog || !istObjekt(annahmen)) return null;
    var a = rechnerAnnahmen(annahmen);
    var preis = Number(preisCent) > 0 ? Number(preisCent) / 100 : 0;
    var k = R.rechne({ verkaeufe: prog.verkaeufe[0], preis: annahmen.bon, tage: annahmen.tage, geraetPreis: preis }, a);
    var e = R.rechne({ verkaeufe: prog.verkaeufe[1], preis: annahmen.bon, tage: annahmen.tage, geraetPreis: preis }, a);
    return k && e ? { konservativ: k, erwartet: e } : null;
  }

  // Rate in Verkaeufen: Verkaeufe am Tag, bei denen der Ueberschuss den Geraetepreis netto in rateMonate deckt.
  // Der Ueberschuss von rechne() ist in den Verkaeufen linear: U(v) = U(0) + v x (U(1) - U(0)).
  function rateVerkaeufe(preisCent, annahmen) {
    var R = rechner();
    var monate = istObjekt(annahmen) ? Number(annahmen.rateMonate) : NaN;
    if (!R || !(Number(preisCent) > 0) || !(monate > 0)) return null;
    var a = rechnerAnnahmen(annahmen);
    var u0 = R.rechne({ verkaeufe: 0, preis: annahmen.bon, tage: annahmen.tage, geraetPreis: 0 }, a);
    var u1 = R.rechne({ verkaeufe: 1, preis: annahmen.bon, tage: annahmen.tage, geraetPreis: 0 }, a);
    if (!u0 || !u1) return null;
    var jeVerkauf = u1.ueberschuss - u0.ueberschuss;
    if (!(jeVerkauf > 0)) return null;
    var v = (Number(preisCent) / 100 / monate - u0.ueberschuss) / jeVerkauf;
    return v <= 0 ? 0 : Math.ceil(v - 1e-9);
  }

  function stromkostenJahr(kwh, strompreis) {
    var k = Number(kwh);
    var p = Number(strompreis);
    return isFinite(k) && k > 0 && isFinite(p) && p >= 0 ? Math.round(k * p) : null;
  }

  // ---------------------------------------------------------------------------------- Links

  function finderUrl(basis, zustand) {
    var z = normalisiereZustand(zustand);
    var teile = [];
    if (z.aufstellort) teile.push('standort=' + (z.aufstellort === 'innen' ? 'indoor' : 'outdoor'));
    if (z.sortiment) teile.push('sortiment=' + z.sortiment);
    if (hat(GROESSE_ZIEL, z.groesse)) teile.push('groesse=' + GROESSE_ZIEL[z.groesse]);
    var b = text(basis) || '/pages/automaten-finder';
    return b + (teile.length ? (b.indexOf('?') === -1 ? '?' : '&') + teile.join('&') : '');
  }

  function kalkulatorUrl(basis, preisCent, prog, annahmen) {
    var R = rechner();
    var b = text(basis) || '/pages/automaten-kalkulator';
    if (!R || typeof R.kalkulatorLink !== 'function') return b;
    var werte = prog && istObjekt(annahmen) && typeof R.kalkulatorWerte === 'function'
      ? R.kalkulatorWerte({ verkaeufe: prog.verkaeufe[1], preis: annahmen.bon }, { wareneinsatz: annahmen.wareneinsatz })
      : null;
    return R.kalkulatorLink(b, Number(preisCent) > 0 ? Math.floor(Number(preisCent) / 100) : null, werte);
  }

  function produktUrl(c) {
    if (!c) return '';
    var u = c.geraet.url.split('#')[0];
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(c.variante.id);
  }

  // ---------------------------------------------------------------------------------- Texte

  function label(feld, wert, labels) {
    var l = istObjekt(labels) && istObjekt(labels[feld]) ? labels[feld][wert] : '';
    return l || (hat(LABELS, feld) && LABELS[feld][wert]) || text(wert);
  }

  function gross(s) {
    var t = text(s);
    return t ? t.charAt(0).toUpperCase() + t.slice(1) : t;
  }

  function geraetName(c) {
    if (!c) return '';
    var t = c.variante.titel;
    return c.geraet.title + (t ? ' ' + t : '');
  }

  function spanneText(prog) {
    if (!prog) return TEXTE.strich;
    var k = prog.verkaeufe[0];
    var e = prog.verkaeufe[1];
    return k === e ? ganz(e) : ersetze(TEXTE.prognose.spanne, { k: ganz(k), e: ganz(e) });
  }

  function verkaeufeText(prog) {
    if (!prog) return TEXTE.strich;
    var k = prog.verkaeufe[0];
    var e = prog.verkaeufe[1];
    if (e < 1) return TEXTE.prognose.verkaeufeNull;
    if (k === e) return ersetze(e === 1 ? TEXTE.prognose.verkaeufeEins : TEXTE.prognose.verkaeufeGleich, { e: ganz(e) });
    return ersetze(TEXTE.prognose.verkaeufe, { k: ganz(k), e: ganz(e) });
  }

  // Kurzform fuer die Kachel "Verkaeufe am Tag": "5 bis 10", "12", "unter 1"
  function verkaeufeKurz(prog) {
    if (!prog) return TEXTE.strich;
    if (prog.verkaeufe[1] < 1) return TEXTE.prognose.unterEins;
    return spanneText(prog);
  }

  // Geldspanne "\u2248 230 bis 460 \u20ac" (rechner: zahlText/euroText)
  function geldSpanne(g, feld) {
    var R = rechner();
    if (!R || !g) return TEXTE.strich;
    var k = g.konservativ[feld];
    var e = g.erwartet[feld];
    if (Math.round(k) === Math.round(e)) return TEXTE.ca + TEXTE.nbsp + R.euroText(e);
    return TEXTE.ca + TEXTE.nbsp + R.zahlText(R.runde(k)) + ' bis ' + R.euroText(e);
  }

  function faktorTexte(b, labels) {
    var z = b.zustand;
    var f = b.faktoren;
    var aus = {};
    var pub = z.publikum === 'fluechtig' ? 'fluechtig' : 'gebunden';
    var kaeufe = f.nachfrage.kaeufe;
    aus.nachfrage = {
      grund: gross(ersetze(TEXTE.grund.nachfrage, { klasse: label('groesse', z.groesse, labels), publikum: TEXTE.grund.publikum[pub], kaeufe: kaeufe == null ? TEXTE.strich : dezimal(kaeufe, kaeufe < 10 ? 1 : 0) })),
      tipp: TEXTE.tipp.nachfrage[pub],
      link: pub === 'gebunden' ? 'sortiment' : 'standort'
    };
    aus.zugang = { grund: TEXTE.grund.zugang[z.zugang] || '', tipp: z.zugang === 'rund' ? TEXTE.tipp.zugang.rund : TEXTE.tipp.zugang.sonst, link: z.zugang === 'rund' ? 'aufstellungsvertrag' : 'standort' };
    var sichtGrund = z.sicht === 'pause' ? (pub === 'gebunden' ? TEXTE.grund.sicht.pauseGebunden : TEXTE.grund.sicht.pauseFluechtig) : (TEXTE.grund.sicht[z.sicht] || '');
    aus.sicht = { grund: sichtGrund, tipp: z.sicht === 'eingang' ? TEXTE.tipp.sicht.eingang : TEXTE.tipp.sicht.sonst, link: 'standort' };
    var vGrund = TEXTE.grund.versorgung[z.versorgung] || '';
    if (z.versorgung !== 'keine' && z.zugang === 'rund' && vGrund) vGrund += TEXTE.grund.versorgung.rund;
    aus.versorgung = { grund: vGrund, tipp: z.versorgung === 'keine' ? TEXTE.tipp.versorgung.keine : TEXTE.tipp.versorgung.sonst, link: z.versorgung === 'keine' ? 'sortiment' : 'lohnt' };
    var m = f.machbarkeit;
    var stromText = gross(TEXTE.grund.strom[z.strom] || '');
    var mGrund;
    if (m.bestes && m.bestes.passform.tuer === 'unbekannt' && m.bestes.passform.platz === 'unbekannt') mGrund = ersetze(TEXTE.grund.ohneMasse, { strom: stromText });
    else if (m.bestes) mGrund = ersetze(TEXTE.grund.machbarkeit, { strom: stromText, geraet: geraetName(m.bestes), weg: TEXTE.grund.passform[m.bestes.passform.tuer], platz: TEXTE.grund.passform[m.bestes.passform.platz] });
    else mGrund = ersetze(TEXTE.grund.ohneGeraet, { strom: stromText });
    if (z.treppe === 'ja') mGrund += TEXTE.grund.treppe;
    else if (z.treppe === 'aufzug') mGrund += TEXTE.grund.aufzug;
    var tipp;
    var link;
    var aussen = z.aufstellort === 'ueberdacht' || z.aufstellort === 'frei';
    if (m.teile.strom != null && m.teile.strom < 1) { tipp = TEXTE.tipp.machbarkeit.strom; link = 'strom'; }
    else if (m.bestes && m.bestes.passform.tuer !== 'passt') { tipp = TEXTE.tipp.machbarkeit.weg; link = 'transport'; }
    else if (m.bestes && m.bestes.passform.platz !== 'passt') { tipp = TEXTE.tipp.machbarkeit.platz; link = 'standort'; }
    else if (aussen) { tipp = TEXTE.tipp.machbarkeit.outdoor; link = 'outdoor'; }
    else { tipp = TEXTE.tipp.machbarkeit.gut; link = 'transport'; }
    aus.machbarkeit = { grund: mGrund, tipp: tipp, link: link };
    for (var n in aus) if (hat(aus, n)) {
      aus[n].href = WISSEN[aus[n].link];
      aus[n].linkText = TEXTE.tippLink[aus[n].link];
    }
    return aus;
  }

  function zusammenfassung(b) {
    var satz = b.ko.length ? TEXTE.satz.ko : TEXTE.satz[b.ampel];
    if (b.deckel != null && !b.ko.length) satz += TEXTE.satz.deckel;
    return satz;
  }

  function koTexte(b) {
    var aus = [];
    for (var i = 0; i < b.ko.length; i++) {
      if (b.ko[i] === 'strom') aus.push({ code: 'strom', text: TEXTE.ko.strom, link: 'strom', href: WISSEN.strom, linkText: TEXTE.tippLink.strom });
      if (b.ko[i] === 'tuer') aus.push({ code: 'tuer', text: ersetze(TEXTE.ko.tuer, { cm: ganz(wegVon(b.zustand).tuer) }), link: 'transport', href: WISSEN.transport, linkText: TEXTE.tippLink.transport });
    }
    return aus;
  }

  function empfehlungsGrund(c, zustand, labels) {
    if (!c) return '';
    var z = normalisiereZustand(zustand);
    var pf = c.passform;
    var teile = [];
    var b = pf.braucht || {};
    teile.push(ersetze(TEXTE.empfehlung.weg[pf.tuer], { cm: ganz(b.tuer || 0) }));
    teile.push(ersetze(TEXTE.empfehlung.platz[pf.platz], { b: ganz(b.breite || 0), t: ganz(b.tiefe || 0) }));
    if (c.variante.auswahlen) teile.push(ersetze(TEXTE.empfehlung.auswahlen, { n: ganz(c.variante.auswahlen), klasse: label('groesse', z.groesse, labels) }));
    if (c.geraet.standort === 'outdoor') teile.push(TEXTE.empfehlung.outdoor);
    return gross(teile.join(', ')) + '.';
  }

  function kurzfassungTeile(b, prog, labels) {
    var z = b.zustand;
    var w = wegVon(z);
    var teile = [ersetze(TEXTE.kurz.kopf, { p: b.punkte, ampel: TEXTE.ampel[b.ampel] })];
    ['typ', 'publikum', 'groesse', 'zugang', 'sicht', 'versorgung', 'sortiment', 'aufstellort', 'strom'].forEach(function (f) {
      if (z[f] !== undefined) teile.push(KURZ[f] + ': ' + label(f, z[f], labels));
    });
    teile.push(KURZ.tuer + ': ' + ersetze(TEXTE.kurz.tuer, { cm: w.tuer }));
    teile.push(KURZ.treppe + ': ' + label('treppe', w.treppe, labels));
    teile.push(KURZ.breite + ': ' + ersetze(TEXTE.kurz.flaeche, { b: w.breite, t: w.tiefe }) + ' (' + label('masse', w.masse, labels) + ')');
    teile.push(ersetze(TEXTE.kurz.verkaeufe, { spanne: spanneText(prog) }));
    if (b.empfehlung) teile.push(ersetze(TEXTE.kurz.empfehlung, { geraet: geraetName(b.empfehlung) }));
    return teile;
  }

  function kurzfassung(b, prog, labels) {
    var R = rechner();
    var teile = kurzfassungTeile(b, prog, labels);
    if (R && typeof R.konfigurationText === 'function') return R.konfigurationText(teile);
    return teile.join(TEXTE.trenner).slice(0, 900);
  }

  function nachricht(b, prog, link) {
    var s = ersetze(TEXTE.kurz.nachricht, {
      p: b.punkte,
      ampel: TEXTE.ampel[b.ampel],
      spanne: spanneText(prog),
      geraet: b.empfehlung ? ersetze(TEXTE.kurz.nachrichtGeraet, { geraet: geraetName(b.empfehlung) }) : '',
      link: text(link)
    });
    return s.slice(0, 2000);
  }

  function whatsappText(basisText, b, link) {
    return ersetze(TEXTE.kurz.whatsapp, { text: text(basisText).trim(), p: b.punkte, ampel: TEXTE.ampel[b.ampel], link: text(link) }).trim();
  }

  // Rechenweg und Annahmen als Saetze (Ergebnis und Druck)
  function rechenweg(prog, a) {
    if (!prog) return '';
    var R = rechner();
    var euro = function (n) { return R ? R.zahlText(n, 2) : dezimal(n, 2); };
    return ersetze(TEXTE.prognose.rechenweg, {
      pk: ganz(prog.personen[0]), pe: ganz(prog.personen[1]), quote: dezimal(prog.quote, 2),
      s: faktorText(prog.faktoren.sicht), z: faktorText(prog.faktoren.zugang), v: faktorText(prog.faktoren.versorgung),
      k: ganz(prog.verkaeufe[0]), e: ganz(prog.verkaeufe[1]), bon: euro(a.bon), tage: ganz(a.tage),
      we: dezimal(a.wareneinsatz, 2), mi: dezimal(a.mieteProzent, 2), gk: dezimal(a.grundkosten, 2),
      ust: a.ustAbziehen !== false ? ersetze(TEXTE.prognose.ust, { mw: dezimal(a.mwst, 2) }) : ''
    });
  }

  function annahmenText(a) {
    var R = rechner();
    var euro = function (n) { return R ? R.zahlText(n, 2) : dezimal(n, 2); };
    return ersetze(TEXTE.prognose.annahmen, {
      qg: dezimal(a.quoteGebunden, 2), qf: dezimal(a.quoteFluechtig, 2), bon: euro(a.bon), tage: ganz(a.tage),
      we: dezimal(a.wareneinsatz, 2), gk: dezimal(a.grundkosten, 2), kf: dezimal(a.karteFix, 2), kp: dezimal(a.karteProzent, 2),
      ka: dezimal(a.kartenanteil, 2), mi: dezimal(a.mieteProzent, 2),
      ustText: a.ustAbziehen !== false ? ersetze(TEXTE.prognose.ustAn, { mw: dezimal(a.mwst, 2) }) : TEXTE.prognose.ustAus,
      sp: dezimal(a.strompreis, 2), rm: ganz(a.rateMonate)
    });
  }

  // Zeilen der Vergleichstabelle je Kandidat: { schluessel: [Text, Status?] }
  function tabellenZellen(c, a, prog) {
    var R = rechner();
    var v = c.variante;
    var pf = c.passform;
    var b = pf.braucht || {};
    var zellen = {};
    zellen.preis = { text: v.preis ? ersetze(TEXTE.tabelle.preisWert, { preis: ganz(Math.floor(v.preis / 100)) }) : TEXTE.tabelle.unbekannt };
    // Masse wie im Katalog ohne Tausenderpunkt (Z-04: "1830 \u00d7 1125 \u00d7 845 mm")
    zellen.masse = { text: v.masse ? ersetze(TEXTE.tabelle.masseWert, { h: v.masse.h, b: v.masse.b, t: v.masse.t }) : TEXTE.tabelle.unbekannt };
    zellen.weg = { status: pf.tuer, text: TEXTE.tabelle.status[pf.tuer], detail: b.tuer ? ersetze(TEXTE.tabelle.braucht, { cm: ganz(b.tuer) }) : '' };
    zellen.platz = { status: pf.platz, text: TEXTE.tabelle.status[pf.platz], detail: b.breite ? ersetze(TEXTE.tabelle.brauchtFlaeche, { b: ganz(b.breite), t: ganz(b.tiefe) }) : '' };
    zellen.gewicht = { text: v.kg ? ersetze(TEXTE.tabelle.kg, { kg: ganz(v.kg) }) : TEXTE.tabelle.unbekannt };
    var strom = [];
    if (v.watt) strom.push(ersetze(TEXTE.tabelle.watt, { w: ganz(v.watt) }));
    if (c.geraet.anschluss) strom.push(c.geraet.anschluss);
    zellen.strom = { text: strom.length ? strom.join(TEXTE.trenner) : TEXTE.tabelle.unbekannt };
    zellen.energie = { text: v.kwh ? ersetze(v.klasse ? TEXTE.tabelle.energieWert : TEXTE.tabelle.energieOhneKlasse, { klasse: v.klasse, kwh: ganz(v.kwh) }) : TEXTE.tabelle.unbekannt };
    var kosten = stromkostenJahr(v.kwh, a.strompreis);
    zellen.stromkosten = { text: kosten == null ? TEXTE.tabelle.unbekannt : ersetze(TEXTE.tabelle.kosten, { betrag: ganz(kosten) }) };
    var g = v.preis ? geld(prog, a, v.preis) : null;
    var bez = TEXTE.strich;
    if (g && g.erwartet) {
      var e = g.erwartet;
      if (e.status === 'ok') bez = ersetze(e.monate === 1 ? TEXTE.tabelle.monat : TEXTE.tabelle.monate, { n: ganz(e.monate) });
      else if (e.status === 'lang') bez = TEXTE.tabelle.lang;
      else if (e.status === 'nie') bez = TEXTE.tabelle.nie;
    }
    zellen.bezahlt = { text: R ? bez : TEXTE.strich };
    var rate = v.preis ? rateVerkaeufe(v.preis, a) : null;
    zellen.rate = { text: rate == null ? TEXTE.strich : ersetze(rate === 1 ? TEXTE.tabelle.rateEins : TEXTE.tabelle.rateWert, { v: ganz(rate), m: ganz(a.rateMonate) }) };
    return zellen;
  }

  // ---------------------------------------------------------------------------------- Kundenkonto (Paket A-2b)

  var KONTO_WERKZEUG = 'standort-check';
  var TITEL_MAX = 80;

  // Titel fuer "Meine Werkzeuge" (Backend kuerzt auf 80 Zeichen): Leerraum zusammengefasst, sonst mit Auslassung
  function kurzTitel(t) {
    var s = text(t).replace(/\s+/g, ' ').trim();
    return s.length > TITEL_MAX ? s.slice(0, TITEL_MAX - 1).replace(/\s+$/, '') + '\u2026' : s;
  }

  // Stand { v: 1, zustand, annahmen, titel }: Antworten und eigene Annahmen normalisiert (wie kodiere), titel aus den
  // Antworttexten zu Standorttyp und Sortiment (labels aus dem Markup, LABELS als Rueckfall)
  function kontoStand(zustand, eigene, labels) {
    var z = normalisiereZustand(zustand);
    var s = { v: 1, zustand: z, annahmen: normalisiereAnnahmen(eigene) };
    var teile = [];
    if (z.typ !== undefined) teile.push(label('typ', z.typ, labels));
    if (z.sortiment !== undefined) teile.push(label('sortiment', z.sortiment, labels));
    var titel = kurzTitel(teile.join(' \u00b7 '));
    if (titel) s.titel = titel;
    return s;
  }

  // Nichts beantwortet und keine eigene Annahme: nichts zu behalten
  function kontoLeer(stand) {
    return !istObjekt(stand) || (!Object.keys(normalisiereZustand(stand.zustand)).length && !Object.keys(normalisiereAnnahmen(stand.annahmen)).length);
  }

  // Stand aus Konto oder Spiegel pruefen -> { zustand, annahmen } wie zustandAusUrl, sonst null
  function kontoStandPruefen(stand) {
    if (!istObjekt(stand) || stand.v !== 1) return null;
    return { zustand: normalisiereZustand(stand.zustand), annahmen: normalisiereAnnahmen(stand.annahmen) };
  }

  var api = {
    VERSION: VERSION,
    KONTO_WERKZEUG: KONTO_WERKZEUG,
    kontoStand: kontoStand,
    kontoLeer: kontoLeer,
    kontoStandPruefen: kontoStandPruefen,
    FELDER: FELDER,
    SCHRITTE: SCHRITTE,
    ERLAUBT: ERLAUBT,
    CODES: CODES,
    ZAHL_GRENZEN: ZAHL_GRENZEN,
    STANDARD_WEG: STANDARD_WEG,
    GEWICHTE: GEWICHTE,
    MACHBARKEIT: MACHBARKEIT,
    WERTE: WERTE,
    NACHFRAGE_ZIEL: NACHFRAGE_ZIEL,
    NACHFRAGE_DECKEL: NACHFRAGE_DECKEL,
    AMPEL: AMPEL,
    KO_DECKEL: KO_DECKEL,
    PERSONEN: PERSONEN,
    SPIEL: SPIEL,
    SCHWELLEN: SCHWELLEN,
    MAX_GERAETE: MAX_GERAETE,
    STANDARD_ANNAHMEN: STANDARD_ANNAHMEN,
    JE_TYP: JE_TYP,
    ANNAHMEN: ANNAHMEN,
    STANDORTTYP_ANFRAGE: STANDORTTYP_ANFRAGE,
    WISSEN: WISSEN,
    LABELS: LABELS,
    KURZ: KURZ,
    FAKTOR_NAMEN: FAKTOR_NAMEN,
    TEXTE: TEXTE,
    zahlDe: zahlDe,
    normalisiereZustand: normalisiereZustand,
    normalisiereAnnahmen: normalisiereAnnahmen,
    annahmenFuer: annahmenFuer,
    standardAnnahme: standardAnnahme,
    ersterOffenerSchritt: ersterOffenerSchritt,
    vollstaendig: vollstaendig,
    kodiere: kodiere,
    dekodiere: dekodiere,
    zustandAusUrl: zustandAusUrl,
    wegVon: wegVon,
    masseAus: masseAus,
    kwhAus: kwhAus,
    wattAus: wattAus,
    kgAus: kgAus,
    energieKlasse: energieKlasse,
    geraeteAus: geraeteAus,
    passform: passform,
    groesseVon: groesseVon,
    kandidaten: kandidaten,
    faktoren: faktoren,
    bewertung: bewertung,
    prognose: prognose,
    verbindeRechner: verbindeRechner,
    rechner: rechner,
    geld: geld,
    rateVerkaeufe: rateVerkaeufe,
    stromkostenJahr: stromkostenJahr,
    finderUrl: finderUrl,
    kalkulatorUrl: kalkulatorUrl,
    produktUrl: produktUrl,
    geraetName: geraetName,
    spanneText: spanneText,
    verkaeufeText: verkaeufeText,
    verkaeufeKurz: verkaeufeKurz,
    geldSpanne: geldSpanne,
    faktorTexte: faktorTexte,
    zusammenfassung: zusammenfassung,
    koTexte: koTexte,
    empfehlungsGrund: empfehlungsGrund,
    kurzfassungTeile: kurzfassungTeile,
    kurzfassung: kurzfassung,
    nachricht: nachricht,
    whatsappText: whatsappText,
    rechenweg: rechenweg,
    annahmenText: annahmenText,
    tabellenZellen: tabellenZellen
  };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = api;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  window.__mvSortiment = window.__mvSortiment || {};
  var MV = window.__mvSortiment;
  if (MV.standort) return;
  MV.standort = api;

  var GESAMT = SCHRITTE.length;
  var instanzen = typeof WeakMap === 'function' ? new WeakMap() : null;
  var letzteEingabe = 'zeiger';
  var aktiveDruckWurzel = null;

  function publiziere(name, daten) {
    try {
      var s = window.Shopify;
      if (s && s.analytics && typeof s.analytics.publish === 'function') s.analytics.publish(name, daten);
    } catch (e) { /* Analytics darf den Check nie stoppen */ }
  }

  function bewegungReduziert() {
    try {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) {
      return false;
    }
  }

  function attr(el, name, ersatz) {
    var w = el ? el.getAttribute(name) : null;
    return w == null || w === '' ? ersatz : w;
  }

  function setzeText(el, inhalt) {
    if (el && el.textContent !== inhalt) el.textContent = inhalt;
  }

  function leere(el) {
    while (el && el.firstChild) el.removeChild(el.firstChild);
  }

  function element(name, klasse, inhalt) {
    var el = document.createElement(name);
    if (klasse) el.className = klasse;
    if (inhalt != null) el.textContent = inhalt;
    return el;
  }

  function Check(wurzel) {
    this.w = wurzel;
    this.form = wurzel.querySelector('[data-mv-standort-form]');
    this.z = {};
    this.eigene = {};
    this.schritt = 1;
    this.daten = null;
    this.geraete = null;
    this.labels = null;
    this.letzterSchluessel = '';
    this.timer = 0;
    this.letzteBewertung = null;
  }

  Check.prototype.el = function (selektor) {
    return this.w.querySelector(selektor);
  };

  Check.prototype.alle = function (selektor) {
    return Array.prototype.slice.call(this.w.querySelectorAll(selektor));
  };

  Check.prototype.geraeteLesen = function () {
    if (this.geraete) return this.geraete;
    var el = this.el('script[data-mv-standort-daten]');
    var d = { geraete: [] };
    if (el) {
      try {
        d = JSON.parse(el.textContent || '{}');
      } catch (e) {
        if (window.console && console.warn) console.warn('mv-standort: Daten-JSON nicht lesbar', e);
      }
    }
    this.daten = d;
    this.geraete = geraeteAus(d);
    return this.geraete;
  };

  // Antworttexte aus dem Markup (Liquid ist die Quelle der sichtbaren Texte; LABELS nur als Rueckfall)
  Check.prototype.labelsLesen = function () {
    if (this.labels) return this.labels;
    var labels = {};
    this.alle('input[type="radio"][name]').forEach(function (input) {
      var feld = input.name;
      if (!hat(ERLAUBT, feld)) return;
      var titel = input.closest('label') ? input.closest('label').querySelector('[data-mv-standort-label]') : null;
      if (!labels[feld]) labels[feld] = {};
      if (titel && titel.textContent.trim()) labels[feld][input.value] = titel.textContent.replace(/\s+/g, ' ').trim();
    });
    if (labels.groesse) {
      for (var k in labels.groesse) if (hat(labels.groesse, k) && !/Person/.test(labels.groesse[k])) labels.groesse[k] += ' Personen';
    }
    this.labels = labels;
    return labels;
  };

  Check.prototype.annahmen = function () {
    return annahmenFuer(this.z, this.eigene);
  };

  Check.prototype.feld = function (name) {
    return this.el('[data-mv-standort-feld="' + name + '"]');
  };

  Check.prototype.eingabenSetzen = function () {
    var z = this.z;
    var w = wegVon(z);
    this.alle('input[type="radio"][name]').forEach(function (input) {
      if (!hat(ERLAUBT, input.name)) return;
      var wert = enthaelt(['treppe', 'masse'], input.name) ? w[input.name] : z[input.name];
      input.checked = wert === input.value;
    });
    var self = this;
    ZAHL_FELDER.forEach(function (name) {
      var el = self.feld(name);
      if (el) {
        el.value = String(w[name]);
        el.removeAttribute('aria-invalid');
      }
    });
  };

  Check.prototype.annahmenSetzen = function () {
    var a = this.annahmen();
    var self = this;
    ANNAHMEN.forEach(function (d) {
      var el = self.el('[data-mv-standort-annahme="' + d[0] + '"]');
      if (!el) return;
      if (el.type === 'checkbox') el.checked = a[d[1]] !== false;
      else if (document.activeElement !== el) el.value = String(a[d[1]]);
      el.removeAttribute('aria-invalid');
    });
  };

  Check.prototype.url = function () {
    try {
      var basis = window.location.href.split('#')[0];
      return basis + '#sc=' + kodiere(this.z, this.eigene);
    } catch (e) {
      return '';
    }
  };

  Check.prototype.urlSchreiben = function () {
    try {
      var leer = !Object.keys(this.z).length && !Object.keys(this.eigene).length;
      var hash = leer ? '' : '#sc=' + kodiere(this.z, this.eigene);
      window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search + hash);
    } catch (e) { /* z. B. Sandbox-Iframe ohne History */ }
    // A-2b: jede Aenderung des Zustands laeuft hier durch; mit MVKonto auch in Spiegel und Konto
    if (this.konto) this.kontoSpeichern(false);
  };

  Check.prototype.start = function () {
    var u = zustandAusUrl(window.location.hash, window.location.search);
    // A-2b: ohne Hash und ohne Vorbelegung aus der Adresse kommt der gespeicherte Stand (Spiegel bzw. Konto)
    var mv = kontoApi();
    this.konto = mv;
    this.geaendert = false;
    this.ausLink = !!(Object.keys(u.zustand).length || Object.keys(u.annahmen).length);
    if (mv && !this.ausLink) {
      var e = mv.lokal(api.KONTO_WERKZEUG);
      var s = e ? api.kontoStandPruefen(e.stand) : null;
      if (s) u = s;
    }
    this.z = u.zustand;
    this.eigene = u.annahmen;
    this.geraeteLesen();
    this.eingabenSetzen();
    this.annahmenSetzen();
    var assistent = this.el('[data-mv-standort-assistent]');
    if (assistent) assistent.hidden = false;
    this.w.setAttribute('data-mv-standort-bereit', '');
    var offen = ersterOffenerSchritt(this.z, 1);
    if (offen) this.zeigeSchritt(offen, false);
    else this.zeigeErgebnis(false);
    if (mv) this.kontoStart(mv);
  };

  // ---- Kundenkonto (Paket A-2b) ----------------------------------------------------------------

  // Statuszeile binden; mit Login den Konto-Stand abgleichen
  Check.prototype.kontoStart = function (mv) {
    var self = this;
    this.kontoText = JSON.stringify(api.kontoStand(this.z, this.eigene, this.labelsLesen()));
    // aus dem Snippet der Sektion; fehlt es (Sektion vor A-2b), baut MVKonto die Zeile am Ende des Kopfs
    var box = this.el('[data-mv-konto-hinweis]') || this.el('.mv-standort__kopf');
    if (box && typeof mv.hinweis === 'function') mv.hinweis(box, api.KONTO_WERKZEUG);
    if (typeof mv.eingeloggt !== 'function' || !mv.eingeloggt()) return;
    mv.lesen(api.KONTO_WERKZEUG).then(function (r) { self.kontoAbgleich(r); }, function () { /* Konto nicht erreichbar: Browser-Stand gilt */ });
  };

  // Antwort des Kontos: abweichender Stand (anderes Geraet) oder im Konto geloescht. Auf der Seite schon geaendert:
  // die Seite gilt und geht wieder ins Konto (auch bei nachgehender Geraeteuhr). Aus Hash oder Vorbelegung: der Link
  // gilt. Sonst zeigt die Seite den Konto-Stand (erster offener Schritt bzw. Ergebnis, ohne Fokus).
  Check.prototype.kontoAbgleich = function (r) {
    if (!r || (!r.neu && !r.verworfen)) return;
    if (this.geaendert) {
      this.kontoSpeichern(true);
      return;
    }
    if (this.ausLink) return;
    var s = r.verworfen ? null : api.kontoStandPruefen(r.stand);
    this.z = s ? s.zustand : {};
    this.eigene = s ? s.annahmen : {};
    this.letzterSchluessel = '';
    this.kontoText = JSON.stringify(api.kontoStand(this.z, this.eigene, this.labelsLesen()));
    this.eingabenSetzen();
    this.annahmenSetzen();
    var offen = ersterOffenerSchritt(this.z, 1);
    if (offen) this.zeigeSchritt(offen, false);
    else this.zeigeErgebnis(false);
  };

  // Ganzer Stand in Spiegel und Konto, nur bei einer echten Aenderung (immer = nach dem Abgleich, die Seite gilt);
  // nichts beantwortet (Neu starten) -> loeschen
  Check.prototype.kontoSpeichern = function (immer) {
    var s = api.kontoStand(this.z, this.eigene, this.labelsLesen());
    var t = JSON.stringify(s);
    if (!immer && t === this.kontoText) return;
    this.kontoText = t;
    this.geaendert = true;
    if (api.kontoLeer(s)) this.konto.loeschen(api.KONTO_WERKZEUG);
    else this.konto.speichern(api.KONTO_WERKZEUG, s);
  };

  Check.prototype.fehler = function (meldung) {
    var f = this.el('[data-mv-standort-fehler]');
    if (!f) return;
    if (meldung) f.textContent = meldung;
    f.hidden = !meldung;
  };

  Check.prototype.zeigeSchritt = function (n, fokus) {
    this.schritt = n;
    var aktuell = null;
    this.alle('[data-mv-standort-schritt]').forEach(function (fs) {
      var ist = Number(fs.getAttribute('data-mv-standort-schritt')) === n;
      fs.hidden = !ist;
      if (ist) aktuell = fs;
    });
    var form = this.form;
    if (form) form.hidden = false;
    var erg = this.el('[data-mv-standort-ergebnis]');
    if (erg) erg.hidden = true;
    var zurueck = this.el('[data-mv-standort-zurueck]');
    if (zurueck) zurueck.hidden = n <= 1;
    var weiter = this.el('[data-mv-standort-weiter]');
    if (weiter) weiter.textContent = n >= GESAMT ? attr(weiter, 'data-label-ergebnis', 'Ergebnis anzeigen') : attr(weiter, 'data-label-weiter', 'Weiter');
    this.fehler('');
    this.w.setAttribute('data-mv-standort-stand', String(n));
    var name = aktuell ? attr(aktuell, 'data-mv-standort-kurz', '') : '';
    setzeText(this.el('[data-mv-standort-fortschritt]'), ersetze(TEXTE.fortschritt, { n: n, gesamt: GESAMT, name: name }));
    if (fokus && aktuell) {
      try { aktuell.focus({ preventScroll: true }); } catch (e) { aktuell.focus(); }
      this.inSicht(aktuell);
    }
  };

  Check.prototype.inSicht = function (el) {
    if (!el || !el.getBoundingClientRect || typeof el.scrollIntoView !== 'function') return;
    var r = el.getBoundingClientRect();
    if (r.top < 0 || r.top > (window.innerHeight || 0) * 0.6) {
      try { el.scrollIntoView({ block: 'start', behavior: bewegungReduziert() ? 'auto' : 'smooth' }); } catch (e) { el.scrollIntoView(true); }
    }
  };

  // Schritt 10: Zahlenfelder und die beiden Gruppen lesen; ungueltige Zahl -> Fehler am Feld
  Check.prototype.wegLesen = function () {
    var self = this;
    var ok = true;
    ZAHL_FELDER.forEach(function (name) {
      var el = self.feld(name);
      if (!el) return;
      var w = normWert(name, el.value);
      if (w === undefined) {
        ok = false;
        el.setAttribute('aria-invalid', 'true');
      } else {
        el.removeAttribute('aria-invalid');
        self.z[name] = w;
      }
    });
    ['treppe', 'masse'].forEach(function (name) {
      var gewaehlt = self.el('input[type="radio"][name="' + name + '"]:checked');
      self.z[name] = gewaehlt ? normWert(name, gewaehlt.value) || STANDARD_WEG[name] : STANDARD_WEG[name];
    });
    return ok;
  };

  Check.prototype.weiter = function () {
    if (this.schritt > GESAMT) return;
    if (this.schritt === GESAMT) {
      if (!this.wegLesen()) {
        this.fehler(TEXTE.fehlerZahl);
        var falsch = this.el('[data-mv-standort-feld][aria-invalid="true"]');
        if (falsch) falsch.focus();
        return;
      }
      this.urlSchreiben();
    } else {
      var feld = SCHRITTE[this.schritt - 1][0];
      if (this.z[feld] === undefined) {
        this.fehler(TEXTE.fehler);
        var erstes = this.el('[data-mv-standort-schritt="' + this.schritt + '"] input[type="radio"]');
        if (erstes) erstes.focus();
        return;
      }
    }
    var offen = ersterOffenerSchritt(this.z, this.schritt + 1);
    if (offen) this.zeigeSchritt(offen, true);
    else this.zeigeErgebnis(true);
  };

  Check.prototype.zurueck = function () {
    if (this.schritt > GESAMT) this.zeigeSchritt(GESAMT, true);
    else if (this.schritt > 1) this.zeigeSchritt(this.schritt - 1, true);
  };

  Check.prototype.neustart = function () {
    this.z = {};
    this.eigene = {};
    this.letzterSchluessel = '';
    this.eingabenSetzen();
    this.annahmenSetzen();
    this.urlSchreiben();
    this.zeigeSchritt(1, true);
  };

  Check.prototype.antwort = function (feld, wert) {
    var w = normWert(feld, wert);
    if (w === undefined) return;
    var vorher = this.z.typ;
    this.z[feld] = w;
    if (feld === 'typ' && vorher !== w) this.annahmenSetzen();
    if (this.schritt <= GESAMT && feld !== 'treppe' && feld !== 'masse') this.fehler('');
    this.urlSchreiben();
    publiziere('standort_check_schritt', { schritt: this.schrittVon(feld), feld: feld, wert: w });
    if (this.schritt > GESAMT) this.rendern(false);
  };

  Check.prototype.schrittVon = function (feld) {
    for (var i = 0; i < SCHRITTE.length; i++) if (enthaelt(SCHRITTE[i], feld)) return i + 1;
    return 0;
  };

  // Eigene Annahme setzen; gleich dem Standard -> wieder dem Standard folgen (Typwechsel aendert dann Bon/Tage mit)
  Check.prototype.annahme = function (kurzName, el) {
    var d = null;
    for (var i = 0; i < ANNAHMEN.length; i++) if (ANNAHMEN[i][0] === kurzName) d = ANNAHMEN[i];
    if (!d) return;
    var roh = {};
    roh[d[1]] = el.type === 'checkbox' ? el.checked : el.value;
    var n = normalisiereAnnahmen(roh);
    if (!hat(n, d[1])) {
      el.setAttribute('aria-invalid', 'true');
      return;
    }
    el.removeAttribute('aria-invalid');
    if (n[d[1]] === standardAnnahme(d[1], this.z)) delete this.eigene[d[1]];
    else this.eigene[d[1]] = n[d[1]];
    this.urlSchreiben();
    if (this.schritt > GESAMT) this.rendern(false);
  };

  Check.prototype.annahmenZuruecksetzen = function () {
    this.eigene = {};
    this.annahmenSetzen();
    this.urlSchreiben();
    this.rendern(false);
  };

  Check.prototype.zeigeErgebnis = function (fokus) {
    this.schritt = GESAMT + 1;
    this.alle('[data-mv-standort-schritt]').forEach(function (fs) { fs.hidden = true; });
    if (this.form) this.form.hidden = true;
    this.fehler('');
    this.w.setAttribute('data-mv-standort-stand', 'ergebnis');
    setzeText(this.el('[data-mv-standort-fortschritt]'), TEXTE.ergebnis);
    var erg = this.el('[data-mv-standort-ergebnis]');
    if (erg) erg.hidden = false;
    this.annahmenSetzen();
    this.rendern(true);
    var titel = this.el('[data-mv-standort-ergebnis-titel]');
    if (fokus && titel) {
      try { titel.focus({ preventScroll: true }); } catch (e) { titel.focus(); }
      this.inSicht(titel);
    }
  };

  Check.prototype.slot = function (bereich, name) {
    return bereich ? bereich.querySelector('[data-mv-standort-slot="' + name + '"]') : null;
  };

  Check.prototype.meldungen = function (liste, eintraege) {
    if (!liste) return;
    leere(liste);
    for (var i = 0; i < eintraege.length; i++) {
      var li = element('li', 'mv-standort-meldungen__eintrag');
      li.appendChild(document.createTextNode(eintraege[i].text));
      if (eintraege[i].href || (eintraege[i].link && WISSEN[eintraege[i].link])) {
        li.appendChild(document.createTextNode(' '));
        var a = element('a', 'mv-standort-meldungen__link', eintraege[i].linkText || TEXTE.tippLink[eintraege[i].link]);
        a.href = eintraege[i].href || WISSEN[eintraege[i].link];
        li.appendChild(a);
      }
      liste.appendChild(li);
    }
    liste.hidden = !eintraege.length;
  };

  Check.prototype.rendern = function (melden) {
    var a = this.annahmen();
    var b = bewertung(this.z, this.geraeteLesen(), a);
    var prog = prognose(this.z, a);
    var labels = this.labelsLesen();
    this.letzteBewertung = b;

    // Kopf: Ampel, Punkte, Satz
    var ampel = this.el('[data-mv-standort-ampel]');
    if (ampel) {
      ampel.setAttribute('data-ampel', b.ampel);
      this.alle('[data-mv-standort-ampel-icon]').forEach(function (i) { i.hidden = i.getAttribute('data-mv-standort-ampel-icon') !== b.ampel; });
      setzeText(this.el('[data-mv-standort-ampel-text]'), TEXTE.ampel[b.ampel]);
    }
    setzeText(this.el('[data-mv-standort-punkte]'), String(b.punkte));
    setzeText(this.el('[data-mv-standort-satz]'), zusammenfassung(b));
    this.meldungen(this.el('[data-mv-standort-ko]'), koTexte(b));
    this.meldungen(this.el('[data-mv-standort-hinweise]'), b.hinweise);

    // Faktoren
    var texte = faktorTexte(b, labels);
    var self = this;
    this.alle('[data-mv-standort-faktor]').forEach(function (li) {
      var name = li.getAttribute('data-mv-standort-faktor');
      var f = b.faktoren[name];
      var t = texte[name];
      if (!f || !t) return;
      setzeText(self.slot(li, 'punkte'), ersetze(TEXTE.faktorPunkte, { p: f.punkte, max: f.max }));
      var balken = self.slot(li, 'balken');
      if (balken && balken.style && balken.style.setProperty) balken.style.setProperty('--mvs-standort-anteil', Math.round((f.wert || 0) * 100) + '%');
      li.setAttribute('data-mv-standort-wertung', f.wert == null ? 'offen' : (f.wert >= 0.75 ? 'gut' : (f.wert >= 0.45 ? 'mittel' : 'schwach')));
      setzeText(self.slot(li, 'grund'), t.grund);
      setzeText(self.slot(li, 'tipp'), t.tipp);
      var link = self.slot(li, 'tipp-link');
      if (link) {
        link.setAttribute('href', t.href);
        setzeText(link, t.linkText);
      }
    });

    // Prognose
    var progBereich = this.el('[data-mv-standort-prognose]');
    var empf = b.empfehlung;
    var g = geld(prog, a, empf && empf.variante.preis ? empf.variante.preis : 0);
    setzeText(this.slot(progBereich, 'verkaeufe'), verkaeufeKurz(prog));
    setzeText(this.slot(progBereich, 'umsatz'), geldSpanne(g, 'umsatz'));
    setzeText(this.slot(progBereich, 'ueberschuss'), geldSpanne(g, 'ueberschuss'));
    setzeText(this.slot(progBereich, 'rechenweg'), rechenweg(prog, a));
    setzeText(this.slot(progBereich, 'annahmen-text'), annahmenText(a));

    this.tabelle(b, a, prog);
    this.empfehlung(b, a, prog, labels);
    this.uebergaben(b, a, prog, labels);
    this.angaben(b, labels);

    var status = this.el('[data-mv-standort-status]');
    if (status) status.textContent = ersetze(TEXTE.status.ergebnis, { p: b.punkte, ampel: TEXTE.ampel[b.ampel] });

    var schluessel = kodiere(this.z, this.eigene);
    var detail = { punkte: b.punkte, ampel: b.ampel, ko: b.ko.slice(), zustand: b.zustand, verkaeufe: prog ? prog.verkaeufe.slice() : null, empfehlung: empf ? empf.geraet.handle : null, geraete: b.kandidaten.liste.slice(0, MAX_GERAETE).map(function (c) { return c.geraet.handle; }) };
    if (melden !== false && schluessel !== this.letzterSchluessel) {
      this.letzterSchluessel = schluessel;
      publiziere('standort_check_ergebnis', detail);
    }
    try {
      this.w.dispatchEvent(new CustomEvent('mv:standort:ergebnis', { bubbles: true, detail: detail }));
    } catch (e) { /* alte Browser ohne CustomEvent-Konstruktor */ }
  };

  Check.prototype.tabelle = function (b, a, prog) {
    var bereich = this.el('[data-mv-standort-tabelle]');
    if (!bereich) return;
    leere(bereich);
    var liste = b.kandidaten.liste.slice(0, MAX_GERAETE);
    var hinweis = this.el('[data-mv-standort-slot="geraete-hinweis"]');
    if (!liste.length) {
      bereich.hidden = true;
      setzeText(hinweis, TEXTE.tabelle.keine);
      return;
    }
    bereich.hidden = false;
    setzeText(hinweis, '');
    var T = TEXTE.tabelle;
    var table = element('table', 'mv-standort-tabelle__tabelle');
    table.appendChild(element('caption', 'mv-visually-hidden', T.caption));
    var thead = element('thead');
    var kopf = element('tr');
    var th0 = element('th', '', T.merkmal);
    th0.setAttribute('scope', 'col');
    kopf.appendChild(th0);
    liste.forEach(function (c, i) {
      var th = element('th', 'mv-standort-tabelle__geraet' + (i === 0 ? ' mv-tabelle__aktiv' : ''));
      th.setAttribute('scope', 'col');
      if (c.geraet.bild) {
        var img = element('img', 'mv-standort-tabelle__bild');
        img.src = c.geraet.bild;
        img.alt = '';
        img.width = 96;
        img.height = 96;
        img.loading = 'lazy';
        th.appendChild(img);
      }
      var link = element('a', 'mv-standort-tabelle__name', geraetName(c));
      link.href = produktUrl(c);
      link.setAttribute('data-mv-standort-cta', 'produkt');
      link.setAttribute('data-mv-handle', c.geraet.handle);
      th.appendChild(link);
      if (i === 0) th.appendChild(element('span', 'mv-badge mv-badge--akzent mv-standort-tabelle__badge', T.empfehlung));
      kopf.appendChild(th);
    });
    thead.appendChild(kopf);
    table.appendChild(thead);
    var tbody = element('tbody');
    var zeilen = liste.map(function (c) { return tabellenZellen(c, a, prog); });
    ['preis', 'masse', 'weg', 'platz', 'gewicht', 'strom', 'energie', 'stromkosten', 'bezahlt', 'rate'].forEach(function (schluessel) {
      var tr = element('tr');
      var th = element('th', '', T[schluessel]);
      th.setAttribute('scope', 'row');
      tr.appendChild(th);
      zeilen.forEach(function (z, i) {
        var td = element('td', i === 0 ? 'mv-tabelle__aktiv' : '');
        var zelle = z[schluessel];
        if (zelle.status) {
          var st = element('span', 'mv-standort-status mv-standort-status--' + zelle.status, zelle.text);
          td.appendChild(st);
          if (zelle.detail) td.appendChild(element('span', 'mv-standort-tabelle__detail', zelle.detail));
        } else {
          td.textContent = zelle.text;
        }
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
    table.appendChild(tbody);
    bereich.appendChild(table);
  };

  Check.prototype.empfehlung = function (b, a, prog, labels) {
    var bereich = this.el('[data-mv-standort-empfehlung]');
    if (!bereich) return;
    var karte = this.slot(bereich, 'karte');
    var beratung = this.slot(bereich, 'beratung');
    var c = b.empfehlung;
    if (karte) karte.hidden = !c;
    if (beratung) beratung.hidden = !!c;
    if (!c) return;
    var bild = this.slot(bereich, 'bild');
    var platzhalter = this.slot(bereich, 'bild-platzhalter');
    if (bild) {
      if (c.geraet.bild) bild.setAttribute('src', c.geraet.bild);
      bild.hidden = !c.geraet.bild;
    }
    if (platzhalter) {
      platzhalter.hidden = !!c.geraet.bild;
      setzeText(platzhalter, c.geraet.title.replace(/^SandenVendo\s+/, ''));
    }
    var url = produktUrl(c);
    var titel = this.slot(bereich, 'titel');
    if (titel) {
      setzeText(titel, c.geraet.title);
      titel.setAttribute('href', url);
      titel.setAttribute('data-mv-handle', c.geraet.handle);
    }
    var variante = this.slot(bereich, 'variante');
    if (variante) {
      variante.hidden = !c.variante.titel;
      setzeText(variante, c.variante.titel ? ersetze(TEXTE.empfehlung.variante, { titel: c.variante.titel }) : '');
    }
    setzeText(this.slot(bereich, 'grund'), empfehlungsGrund(c, this.z, labels));
    var alt = this.slot(bereich, 'alternative');
    var altLink = this.slot(bereich, 'alternative-link');
    var alternative = b.alternative;
    if (alt) alt.hidden = !alternative;
    if (alternative && altLink) {
      setzeText(altLink, geraetName(alternative));
      altLink.setAttribute('href', produktUrl(alternative));
      altLink.setAttribute('data-mv-handle', alternative.geraet.handle);
    }
    var vorsatz = this.slot(bereich, 'alternative-vorsatz');
    if (vorsatz) setzeText(vorsatz, b.kandidaten.zweiGeraete ? TEXTE.empfehlung.zwei : TEXTE.empfehlung.alternative);
    var produkt = this.slot(bereich, 'produkt');
    if (produkt) {
      produkt.setAttribute('href', url);
      produkt.setAttribute('data-mv-handle', c.geraet.handle);
    }
  };

  Check.prototype.uebergaben = function (b, a, prog, labels) {
    var c = b.empfehlung;
    var preis = c && c.variante.preis ? c.variante.preis : 0;
    var kalk = this.el('[data-mv-standort-cta="kalkulator"]');
    if (kalk) kalk.setAttribute('href', kalkulatorUrl(attr(kalk, 'data-mv-standort-basis', '/pages/automaten-kalkulator'), preis, prog, a));
    var finder = this.el('[data-mv-standort-cta="finder"]');
    if (finder) finder.setAttribute('href', finderUrl(attr(finder, 'data-mv-standort-basis', '/pages/automaten-finder'), this.z));
    var link = this.url();
    var pruefen = this.el('[data-mv-standort-cta="pruefen"]');
    if (pruefen) {
      var typ = STANDORTTYP_ANFRAGE[this.z.typ] || '';
      var konf = kurzfassung(b, prog, labels);
      pruefen.setAttribute('data-standorttyp', typ);
      pruefen.setAttribute('data-konfiguration', konf);
      pruefen.setAttribute('data-nachricht', nachricht(b, prog, link));
      var produktName = attr(pruefen, 'data-produkt', 'Standort-Check');
      pruefen.setAttribute('href', '/pages/contact?anfrage=1&interesse=' + encodeURIComponent(attr(pruefen, 'data-interesse', 'Beratung')) + '&produkt=' + encodeURIComponent(produktName) + (typ ? '&standorttyp=' + encodeURIComponent(typ) : '') + '&konfiguration=' + encodeURIComponent(konf));
    }
    var wa = this.el('[data-mv-standort-whatsapp]');
    if (wa) {
      var nummer = attr(wa, 'data-mv-standort-nummer', '');
      if (nummer) wa.setAttribute('href', 'https://wa.me/' + nummer + '?text=' + encodeURIComponent(whatsappText(attr(wa, 'data-mv-standort-text', ''), b, link)));
    }
    setzeText(this.el('[data-mv-standort-link-text]'), link);
  };

  Check.prototype.angaben = function (b, labels) {
    var dl = this.el('[data-mv-standort-angaben]');
    if (!dl) return;
    leere(dl);
    var z = b.zustand;
    var w = wegVon(z);
    var paare = [];
    ['typ', 'publikum', 'groesse', 'zugang', 'sicht', 'versorgung', 'sortiment', 'aufstellort', 'strom'].forEach(function (f) {
      if (z[f] !== undefined) paare.push([KURZ[f], label(f, z[f], labels)]);
    });
    paare.push([KURZ.tuer, ersetze(TEXTE.kurz.tuer, { cm: w.tuer })]);
    paare.push([KURZ.treppe, label('treppe', w.treppe, labels)]);
    paare.push([KURZ.breite, ersetze(TEXTE.kurz.flaeche, { b: w.breite, t: w.tiefe })]);
    paare.push([KURZ.masse, label('masse', w.masse, labels)]);
    paare.forEach(function (p) {
      var div = element('div', 'mv-standort-angaben__paar');
      div.appendChild(element('dt', 'mv-standort-angaben__frage', p[0]));
      div.appendChild(element('dd', 'mv-standort-angaben__antwort', p[1]));
      dl.appendChild(div);
    });
  };

  Check.prototype.linkKopieren = function () {
    var link = this.url();
    var status = this.el('[data-mv-standort-link-status]');
    function melde(t) { if (status) status.textContent = t; }
    try {
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(link).then(function () { melde(TEXTE.status.kopiert); }, function () { melde(TEXTE.status.kopierenFehler); });
        return;
      }
    } catch (e) { /* weiter zum Hinweis */ }
    melde(TEXTE.status.kopierenFehler);
  };

  Check.prototype.drucken = function () {
    druckVorbereiten(this.w);
    try {
      window.print();
    } catch (e) { /* Druck nicht moeglich, z. B. in eingebetteten Ansichten */ }
  };

  function druckVorbereiten(wurzel) {
    aktiveDruckWurzel = wurzel;
    document.documentElement.setAttribute('data-mv-standort-druck', '');
  }

  function druckEnde() {
    aktiveDruckWurzel = null;
    document.documentElement.removeAttribute('data-mv-standort-druck');
  }

  // MVKonto (assets/mv-sortiment.konto.js) steht im Buendel vor dieser Datei; trotzdem erst beim Aufruf aufloesen.
  // Ohne MVKonto (oder ohne die Erweiterung lokal von A-2a) bleibt der Zustand wie bisher nur im Hash.
  function kontoApi() {
    var k = window.MVKonto;
    return k && typeof k.lokal === 'function' && typeof k.speichern === 'function' && typeof k.lesen === 'function' &&
      typeof k.loeschen === 'function' ? k : null;
  }

  function instanz(wurzel) {
    if (!wurzel) return null;
    var c = instanzen ? instanzen.get(wurzel) : wurzel.__mvStandort;
    if (c) return c;
    c = new Check(wurzel);
    if (instanzen) instanzen.set(wurzel, c);
    else wurzel.__mvStandort = c;
    try {
      c.start();
    } catch (e) {
      if (window.console && console.error) console.error('mv-standort: Start fehlgeschlagen', e);
    }
    return c;
  }

  function wurzelVon(ziel) {
    return ziel && ziel.closest ? ziel.closest('[data-mv-standort]') : null;
  }

  function alleStarten(bereich) {
    var liste = (bereich || document).querySelectorAll('[data-mv-standort]');
    for (var i = 0; i < liste.length; i++) instanz(liste[i]);
  }

  document.addEventListener('pointerdown', function () { letzteEingabe = 'zeiger'; }, true);
  document.addEventListener('keydown', function () { letzteEingabe = 'tastatur'; }, true);

  document.addEventListener('change', function (e) {
    var el = e.target;
    var wurzel = wurzelVon(el);
    if (!wurzel) return;
    var c = instanz(wurzel);
    if (!c) return;
    if (el.hasAttribute && el.hasAttribute('data-mv-standort-annahme')) {
      c.annahme(el.getAttribute('data-mv-standort-annahme'), el);
      return;
    }
    if (el.type === 'radio' && hat(ERLAUBT, el.name) && el.checked) {
      c.antwort(el.name, el.value);
      return;
    }
    if (el.hasAttribute && el.hasAttribute('data-mv-standort-feld') && enthaelt(ZAHL_FELDER, el.getAttribute('data-mv-standort-feld'))) {
      var name = el.getAttribute('data-mv-standort-feld');
      var w = normWert(name, el.value);
      if (w === undefined) el.setAttribute('aria-invalid', 'true');
      else {
        el.removeAttribute('aria-invalid');
        c.z[name] = w;
        c.urlSchreiben();
      }
    }
  });

  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.hasAttribute || !el.hasAttribute('data-mv-standort-annahme') || el.type === 'checkbox') return;
    var c = instanz(wurzelVon(el));
    if (c) c.annahme(el.getAttribute('data-mv-standort-annahme'), el);
  });

  // Zeiger-Klick auf eine Kachel springt nach 160 ms weiter (Schritte 1-9); Tastatur bleibt stehen (Enter oder "Weiter")
  document.addEventListener('click', function (e) {
    var ziel = e.target;
    var wurzel = wurzelVon(ziel);
    if (!wurzel) return;
    var c = instanz(wurzel);
    if (!c) return;
    if (ziel.closest('[data-mv-standort-zurueck]')) { e.preventDefault(); c.zurueck(); return; }
    if (ziel.closest('[data-mv-standort-neustart]')) { e.preventDefault(); c.neustart(); return; }
    if (ziel.closest('[data-mv-standort-aendern]')) { e.preventDefault(); c.zeigeSchritt(1, true); return; }
    if (ziel.closest('[data-mv-standort-annahmen-zuruecksetzen]')) { e.preventDefault(); c.annahmenZuruecksetzen(); return; }
    if (ziel.closest('[data-mv-standort-pdf]')) { e.preventDefault(); c.drucken(); return; }
    if (ziel.closest('[data-mv-standort-link-kopieren]')) { e.preventDefault(); c.linkKopieren(); return; }
    var cta = ziel.closest('[data-mv-standort-cta], [data-mv-standort-whatsapp]');
    if (cta) {
      publiziere('standort_check_cta', {
        ziel: cta.hasAttribute('data-mv-standort-whatsapp') ? 'whatsapp' : cta.getAttribute('data-mv-standort-cta'),
        handle: cta.getAttribute('data-mv-handle') || null,
        punkte: c.letzteBewertung ? c.letzteBewertung.punkte : null
      });
      return;
    }
    var option = ziel.closest('label');
    var schrittEl = option ? option.closest('[data-mv-standort-schritt]') : null;
    if (!schrittEl || letzteEingabe !== 'zeiger') return;
    var n = Number(schrittEl.getAttribute('data-mv-standort-schritt'));
    if (n !== c.schritt || n >= GESAMT || c.timer) return;
    c.timer = window.setTimeout(function () {
      c.timer = 0;
      if (c.schritt === n && c.z[SCHRITTE[n - 1][0]] !== undefined) c.weiter();
    }, 160);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('[data-mv-standort-form]')) return;
    e.preventDefault();
    var c = instanz(wurzelVon(form));
    if (c && c.schritt <= GESAMT) c.weiter();
  });

  document.addEventListener('shopify:section:load', function (e) {
    alleStarten(e.target);
  });

  // Druck: auch Strg+P druckt das Ergebnis, solange es sichtbar ist
  window.addEventListener('beforeprint', function () {
    if (aktiveDruckWurzel) return;
    var liste = document.querySelectorAll('[data-mv-standort]');
    for (var i = 0; i < liste.length; i++) {
      var erg = liste[i].querySelector('[data-mv-standort-ergebnis]');
      if (erg && !erg.hidden) {
        druckVorbereiten(liste[i]);
        return;
      }
    }
  });
  window.addEventListener('afterprint', druckEnde);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { alleStarten(document); });
  } else {
    alleStarten(document);
  }
})();
